var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _g2, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _g3, _g4, _path103, _g5, _g6, _g7, _g8, _path104;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderSectionImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "header-section-image_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 540 540"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient",
    x1: -609.35,
    y1: 2345.47,
    x2: -609.35,
    y2: 2346.62,
    gradientTransform: "matrix(17 0 0 -155 10492 363819)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52c7ea",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#52c7ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-2",
    x1: -565.24,
    y1: 2174.95,
    x2: -565.72,
    y2: 2185.05,
    gradientTransform: "matrix(8 0 0 -4 4655 8948.96)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-3",
    x1: -565.21,
    y1: 2174.67,
    x2: -565.69,
    y2: 2184.71,
    gradientTransform: "matrix(8 0 0 -4 4655 8939.96)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-4",
    x1: -565.19,
    y1: 1656.66,
    x2: -565.67,
    y2: 1658.7,
    gradientTransform: "matrix(8 0 0 -1 4655 1881)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-5",
    x1: -565.18,
    y1: 1657.27,
    x2: -565.65,
    y2: 1659.31,
    gradientTransform: "matrix(8 0 0 -1 4655 1876)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-6",
    x1: -565.16,
    y1: 1657.74,
    x2: -565.63,
    y2: 1659.78,
    gradientTransform: "matrix(8 0 0 -1 4655 1872)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-7",
    x1: -565.14,
    y1: 1658.48,
    x2: -565.62,
    y2: 1660.52,
    gradientTransform: "matrix(8 0 0 -1 4655 1866)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-8",
    x1: -565.13,
    y1: 1659.09,
    x2: -565.6,
    y2: 1661.13,
    gradientTransform: "matrix(8 0 0 -1 4655 1861)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-9",
    x1: -565.1,
    y1: 2173.51,
    x2: -565.58,
    y2: 2183.53,
    gradientTransform: "matrix(8 0 0 -4 4655 8906)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-10",
    x1: -565.08,
    y1: 2173.24,
    x2: -565.55,
    y2: 2183.26,
    gradientTransform: "matrix(8 0 0 -4 4655 8898)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-11",
    x1: -565.05,
    y1: 2172.97,
    x2: -565.53,
    y2: 2182.99,
    gradientTransform: "matrix(8 0 0 -4 4655 8890)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-12",
    x1: -565.03,
    y1: 2172.66,
    x2: -565.5,
    y2: 2182.68,
    gradientTransform: "matrix(8 0 0 -4 4655 8883)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-13",
    x1: -565.01,
    y1: 1663.59,
    x2: -565.48,
    y2: 1665.63,
    gradientTransform: "matrix(8 0 0 -1 4655 1824.02)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-14",
    x1: -564.98,
    y1: 2172.25,
    x2: -565.46,
    y2: 2182.27,
    gradientTransform: "matrix(8 0 0 -4 4655 8869)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-15",
    x1: -564.96,
    y1: 1665.03,
    x2: -565.44,
    y2: 1667.07,
    gradientTransform: "matrix(8 0 0 -1 4655 1812.02)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-16",
    x1: -564.94,
    y1: 2171.8,
    x2: -565.42,
    y2: 2181.83,
    gradientTransform: "matrix(8 0 0 -4 4655 8856)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-17",
    x1: -564.92,
    y1: 1666.74,
    x2: -565.4,
    y2: 1668.78,
    gradientTransform: "matrix(8 0 0 -1 4655 1798.02)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-18",
    x1: -564.9,
    y1: 2171.32,
    x2: -565.37,
    y2: 2181.35,
    gradientTransform: "matrix(8 0 0 -4 4655 8844)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-19",
    x1: -564.88,
    y1: 1668.32,
    x2: -565.36,
    y2: 1670.36,
    gradientTransform: "matrix(8 0 0 -1 4655 1785.02)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-20",
    x1: -564.86,
    y1: 1668.93,
    x2: -565.34,
    y2: 1670.97,
    gradientTransform: "matrix(8 0 0 -1 4655 1780.02)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-21",
    x1: -601.65,
    y1: 2345.08,
    x2: -601.65,
    y2: 2346.23,
    gradientTransform: "matrix(15 0 0 -143 9470 335629)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-22",
    x1: -548.06,
    y1: 1652.19,
    x2: -548.53,
    y2: 1654.87,
    gradientTransform: "matrix(7 0 0 -1 4282 1916.04)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-23",
    x1: -548.04,
    y1: 2174.03,
    x2: -548.51,
    y2: 2187.23,
    gradientTransform: "matrix(7 0 0 -4 4282 8960.96)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-24",
    x1: -548.01,
    y1: 2173.52,
    x2: -548.48,
    y2: 2186.72,
    gradientTransform: "matrix(7 0 0 -4 4282 8952.96)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-25",
    x1: -547.99,
    y1: 1654.59,
    x2: -548.46,
    y2: 1657.28,
    gradientTransform: "matrix(7 0 0 -1 4282 1895)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-26",
    x1: -547.97,
    y1: 1655.05,
    x2: -548.44,
    y2: 1657.74,
    gradientTransform: "matrix(7 0 0 -1 4282 1891.04)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-27",
    x1: -547.95,
    y1: 1655.64,
    x2: -548.43,
    y2: 1658.32,
    gradientTransform: "matrix(7 0 0 -1 4282 1886.04)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-28",
    x1: -547.94,
    y1: 1656.21,
    x2: -548.41,
    y2: 1658.89,
    gradientTransform: "matrix(7 0 0 -1 4282 1881)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-29",
    x1: -547.92,
    y1: 1656.67,
    x2: -548.39,
    y2: 1659.35,
    gradientTransform: "matrix(7 0 0 -1 4282 1877.04)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-30",
    x1: -547.9,
    y1: 2171.54,
    x2: -548.37,
    y2: 2184.61,
    gradientTransform: "matrix(7 0 0 -4 4282 8923)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-31",
    x1: -547.87,
    y1: 2171.05,
    x2: -548.34,
    y2: 2184.15,
    gradientTransform: "matrix(7 0 0 -4 4282 8915.96)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-32",
    x1: -547.85,
    y1: 2170.57,
    x2: -548.32,
    y2: 2183.77,
    gradientTransform: "matrix(7 0 0 -4 4282 8907.96)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-33",
    x1: -547.82,
    y1: 2170.12,
    x2: -548.29,
    y2: 2183.22,
    gradientTransform: "matrix(7 0 0 -4 4281.98 8902.04)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-34",
    x1: -547.8,
    y1: 1660.46,
    x2: -548.27,
    y2: 1663.14,
    gradientTransform: "matrix(7 0 0 -1 4282 1844.04)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-35",
    x1: -547.78,
    y1: 2169.4,
    x2: -548.25,
    y2: 2182.5,
    gradientTransform: "matrix(7 0 0 -4 4281.98 8889.04)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-36",
    x1: -547.76,
    y1: 1661.71,
    x2: -548.23,
    y2: 1664.4,
    gradientTransform: "matrix(7 0 0 -1 4282 1833.04)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-37",
    x1: -547.74,
    y1: 2168.56,
    x2: -548.21,
    y2: 2181.73,
    gradientTransform: "matrix(7 0 0 -4 4281.98 8878.02)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-38",
    x1: -547.72,
    y1: 1663.22,
    x2: -548.19,
    y2: 1665.91,
    gradientTransform: "matrix(7 0 0 -1 4282 1820)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-39",
    x1: -547.7,
    y1: 2167.8,
    x2: -548.17,
    y2: 2180.97,
    gradientTransform: "matrix(7 0 0 -4 4281.98 8866)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-40",
    x1: -547.68,
    y1: 1664.47,
    x2: -548.15,
    y2: 1667.16,
    gradientTransform: "matrix(7 0 0 -1 4282 1809)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-41",
    x1: -547.66,
    y1: 1665.06,
    x2: -548.13,
    y2: 1667.74,
    gradientTransform: "matrix(7 0 0 -1 4282 1804)",
    xlinkHref: "#header-section-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "header-section-image_svg__linear-gradient-42",
    x1: -616.53,
    y1: 2253.29,
    x2: -616.53,
    y2: 2253.41,
    gradientTransform: "matrix(22 0 0 -7 14014 15886)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52c7ea",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#52c7ea",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#52c7ea",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "header-section-image_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-1",
    d: "M61.3 358.46l11.27-6.55 11.34 6.55-11.27 6.55-11.34-6.55z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "header-section-image_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-1",
    d: "M66.08 358.46l6.5-3.78 6.55 3.78-6.5 3.78-6.55-3.78z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "header-section-image_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-1",
    d: "M283.39 288.24l11.27-6.55 11.35 6.55-11.27 6.55-11.35-6.55z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "header-section-image_svg__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-1",
    d: "M288.17 288.24l6.51-3.78 6.53 3.78-6.5 3.78-6.54-3.78z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "header-section-image_svg__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-1",
    d: "M310.96 513.36l11.27-6.55 11.34 6.55-11.27 6.55-11.34-6.55z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "header-section-image_svg__clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-1",
    d: "M315.74 513.36l6.5-3.77 6.54 3.77-6.5 3.78-6.54-3.78z"
  })), /*#__PURE__*/React.createElement("style", null, ".header-section-image_svg__cls-1{fill:none}.header-section-image_svg__cls-13,.header-section-image_svg__cls-2,.header-section-image_svg__cls-3{fill:#52c7ea}.header-section-image_svg__cls-3{opacity:.1}.header-section-image_svg__cls-10,.header-section-image_svg__cls-13,.header-section-image_svg__cls-3,.header-section-image_svg__cls-57{isolation:isolate}.header-section-image_svg__cls-4{fill:#0a1a2b}.header-section-image_svg__cls-5{fill:#152935}.header-section-image_svg__cls-7{opacity:.11}.header-section-image_svg__cls-8{fill:#161b20}.header-section-image_svg__cls-9{opacity:.2}.header-section-image_svg__cls-10{opacity:.4}.header-section-image_svg__cls-11{fill:#ec432d}.header-section-image_svg__cls-13{opacity:.6}.header-section-image_svg__cls-56{opacity:.2}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M308.84 345.45a.38.38 0 01-.33-.18.38.38 0 01.13-.51l75.86-44.89a.45.45 0 01.19-.05h62.18l39.82-23.4v-33.57a.38.38 0 01.75 0v33.78a.36.36 0 01-.19.32l-40.09 23.57a.45.45 0 01-.19.05H384.8L309 345.4a.34.34 0 01-.16.05zM293.4 336.54a.38.38 0 01-.19-.7L369.47 291v-35.37a.37.37 0 01.19-.32L408 233a.37.37 0 01.51.13.4.4 0 01-.13.52l-38.19 22.21v35.33a.36.36 0 01-.19.32l-76.44 45a.41.41 0 01-.16.03zM281.69 329.3a.39.39 0 01-.33-.19.37.37 0 01.14-.51l33.76-19.55V278l-107.21-62.19a.37.37 0 01.37-.65l107.4 62.32a.37.37 0 01.19.33v31.46a.36.36 0 01-.19.32l-33.95 19.66a.37.37 0 01-.18.05z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M287.89 262.08l-25.17-.14a.41.41 0 01-.19-.05l-42.36-24.31a.37.37 0 11.37-.64l42.28 24.25 25.08.14a.38.38 0 010 .75zM267.9 320.88a.38.38 0 01-.32-.18.4.4 0 01.13-.52l27.14-15.76v-15.13a.37.37 0 11.74 0v15.35a.38.38 0 01-.18.32l-27.32 15.87a.41.41 0 01-.19.05zM231.51 309.05a.45.45 0 01-.19-.05l-3.25-1.87a.36.36 0 01-.19-.32.39.39 0 01.18-.33l28.3-16.36a.37.37 0 01.51.13.39.39 0 01-.14.52l-27.73 16 2.7 1.54a.37.37 0 01.13.51.36.36 0 01-.32.23zM219.35 316a.29.29 0 01-.18-.05l-9.33-5.41a.37.37 0 01-.19-.32v-13.86a.38.38 0 01.18-.32l43.89-25.9a.37.37 0 11.38.64l-43.7 25.79V310l9.14 5.31a.37.37 0 01.14.51.4.4 0 01-.33.18zM200.92 326.57a.32.32 0 01-.19-.05l-4.73-2.76a.37.37 0 01-.14-.51.36.36 0 01.51-.13l4.77 2.75a.38.38 0 01.14.51.37.37 0 01-.36.19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M190.11 332.76a.45.45 0 01-.19-.05l-12-7a.37.37 0 01-.19-.32v-27.52a.37.37 0 01.19-.32l46.63-26.92v-10.18l-25.34-14.64a.37.37 0 11.37-.64l25.53 14.74a.38.38 0 01.18.32v10.62a.38.38 0 01-.18.32l-46.63 26.92v27.07l11.79 6.9a.38.38 0 01.14.51.39.39 0 01-.3.19zM181.08 338.09a.45.45 0 01-.19 0l-24.3-14.28a.37.37 0 01-.19-.32V272.7l-10-5.81a.36.36 0 01-.13-.51.38.38 0 01.51-.13l10.22 5.91a.37.37 0 01.19.32v50.74l24.12 14.17a.37.37 0 01.13.51.36.36 0 01-.36.19zM170.44 344a.45.45 0 01-.19 0l-71.9-42.11a.38.38 0 01-.18-.32v-6.36L75 281.8a.38.38 0 01-.14-.51.37.37 0 01.51-.14l23.38 13.5a.37.37 0 01.18.32v6.37l71.72 42a.37.37 0 01.13.51.37.37 0 01-.34.15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M88.22 289.15a.38.38 0 01-.37-.38v-17.44l-31.68-18.49a.38.38 0 01-.13-.51.37.37 0 01.51-.14l31.86 18.61a.36.36 0 01.19.32v17.65a.38.38 0 01-.38.38zM56.9 330.9a.38.38 0 010-.75l89.72-.16a.38.38 0 010 .75l-89.72.16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M124.88 330.88a.32.32 0 01-.19-.05l-68.08-39.11a.38.38 0 01-.14-.51.37.37 0 01.51-.14l68.08 39.12a.37.37 0 01.14.51.36.36 0 01-.32.18zM160.55 350a.41.41 0 01-.19-.05l-7.59-4.52H42.4a.38.38 0 010-.75h110.47a.33.33 0 01.19.06l7.68 4.57a.38.38 0 01.13.51.37.37 0 01-.32.18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M103.67 357.7H77.41a.38.38 0 010-.75h26.16l21.12-12.21a.37.37 0 11.37.65l-21.2 12.26a.41.41 0 01-.19.05zM107 368.49H51.1a.38.38 0 010-.75h55.83l27-15.48a.41.41 0 01.18-.05l13.47-.09a.32.32 0 01.19.05l13.9 8.05a.38.38 0 01-.38.65l-13.81-8-13.26.1-27 15.48a.41.41 0 01-.22.04z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M119.27 371.92a.35.35 0 01-.32-.18.36.36 0 01.13-.51l18.84-11a.41.41 0 01.19-.05h10.12a.41.41 0 01.19.05l11.08 6.4 7.43-.1a.38.38 0 110 .75l-7.54.1a.41.41 0 01-.19 0l-11.08-6.41h-9.92l-18.75 10.93a.34.34 0 01-.18.02zM128.17 392.06a.36.36 0 01-.32-.18.37.37 0 01.14-.51L149.27 379a.37.37 0 01.18-.05l18.34-.23a.38.38 0 01.38.37.38.38 0 01-.37.38l-18.24.23-21.2 12.3a.32.32 0 01-.19.06z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M145.22 402.34H120a.32.32 0 01-.19 0L93.9 387.58a.37.37 0 01.37-.65L120 401.6h25.08l20.43-12.14a.36.36 0 01.51.13.37.37 0 01-.13.51l-20.52 12.19a.41.41 0 01-.15.05zM118.13 439.44a.4.4 0 01-.32-.18.39.39 0 01.13-.52l65.52-39.05a.37.37 0 01.51.13.37.37 0 01-.13.51l-65.52 39.05a.33.33 0 01-.19.06z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M145.64 422.74h-34.08a.38.38 0 010-.75h34.08a.38.38 0 010 .75zM93.84 521.2a.38.38 0 01-.19-.7l49.46-28.63.64-50.55a.38.38 0 01.18-.32l55-32.45a.37.37 0 01.51.14.37.37 0 01-.13.51l-54.86 32.34-.63 50.55a.37.37 0 01-.19.32L94 521.15a.45.45 0 01-.16.05z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M130.9 520a.37.37 0 01-.19-.7l37.74-21.56V438a.37.37 0 01.18-.32l40-23.16a.37.37 0 11.37.65l-39.81 23V498a.39.39 0 01-.18.33l-37.93 21.66a.37.37 0 01-.18.01z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M190.92 502.54a.38.38 0 01-.38-.38V439a.36.36 0 01.19-.32L221 421.14a.37.37 0 11.37.65l-30.09 17.4v63a.38.38 0 01-.36.35z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M208.32 511.61a.36.36 0 01-.37-.37v-21.39l-17.22-9.78a.37.37 0 01-.19-.33v-18.3a.37.37 0 01.19-.33.39.39 0 01.38 0l21.94 12.95a.37.37 0 01-.37.65l-21.39-12.63v17.44l17.21 9.77a.39.39 0 01.19.33v21.61a.36.36 0 01-.37.38zM272.46 480.54a.41.41 0 01-.19-.05l-52.87-30.73a.38.38 0 01-.18-.32v-13.92a.38.38 0 01.18-.32l13-7.53a.37.37 0 11.37.65L220 435.74v13.48l52.69 30.62a.39.39 0 01.13.51.37.37 0 01-.36.19z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M276 470.48a.45.45 0 01-.19-.05l-22-12.65h-20.62a.38.38 0 110-.75h20.73a.37.37 0 01.18.05l22.09 12.7a.36.36 0 01.13.51.36.36 0 01-.32.19zM276 502a.35.35 0 01-.19-.06L252 488.11a.36.36 0 01-.19-.32v-12.13l-28.16-16.31a.37.37 0 01-.19-.32v-6.84a.38.38 0 01.75 0v6.62l28.16 16.31a.37.37 0 01.19.32v12.13l23.65 13.75a.36.36 0 01.13.51.37.37 0 01-.34.17zM311.63 465.18a.45.45 0 01-.19-.05l-63.53-36.81a.38.38 0 01-.13-.51.37.37 0 01.51-.14l63.44 36.76h13.83a.37.37 0 01.37.37.37.37 0 01-.37.38h-13.93zM293.36 441.91a.41.41 0 01-.19-.05l-34.45-19.95a.36.36 0 01-.13-.51.37.37 0 01.51-.14l34.45 19.95a.38.38 0 01.13.51.37.37 0 01-.32.19z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M322.59 511.61a.36.36 0 01-.32-.18.37.37 0 01.14-.51l23.14-13.18V459l-75.85-43.1a.37.37 0 11.37-.65l76 43.2a.38.38 0 01.19.32V498a.4.4 0 01-.19.33l-23.33 13.27a.34.34 0 01-.15.01z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M359.71 494.61a.36.36 0 01-.37-.37V476l-13.29-7.74a.37.37 0 01-.14-.51.38.38 0 01.51-.13l13.48 7.84a.39.39 0 01.18.33v18.45a.36.36 0 01-.37.37zM433.38 510.88a.38.38 0 01-.38-.38v-15.2l-151.45-86.93a.37.37 0 11.37-.65l151.64 87a.37.37 0 01.19.33v15.45a.38.38 0 01-.37.38zM496.25 486.55a.45.45 0 01-.19-.05L426.11 446h-57.85a.37.37 0 01-.18 0l-4.22-2.33a.37.37 0 01-.15-.5.38.38 0 01.51-.15l4.13 2.28h57.86a.29.29 0 01.18 0l70.05 40.51a.36.36 0 01.13.51.36.36 0 01-.32.23z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M480.55 493.25a.29.29 0 01-.18-.05l-28.49-16.84a.36.36 0 01-.18-.32v-15.42a.38.38 0 01.75 0v15.21l28.3 16.73a.38.38 0 01.13.51.38.38 0 01-.33.18zM471.68 457.73a.32.32 0 01-.19-.05l-32.55-19.32H373a.37.37 0 010-.74h66a.34.34 0 01.19.05L471.87 457a.37.37 0 01-.19.69zM450.26 431.24h-73.77a.37.37 0 110-.74h73.67l69-39.83a.37.37 0 11.37.65l-69.12 39.87a.29.29 0 01-.15.05zM371.57 403.34a.37.37 0 01-.19-.69l8.48-5a.37.37 0 11.38.64l-8.48 5a.34.34 0 01-.19.05zM361.6 397.35a.38.38 0 01-.19-.7l25.46-14.74a.41.41 0 01.19-.05l40.14-.14a.22.22 0 01.18 0l22.09 12.79a.36.36 0 01.13.51.37.37 0 01-.51.14l-22-12.75-39.94.15-25.36 14.74a.45.45 0 01-.19.05zM325.31 410.66a.45.45 0 01-.19-.05l-23.62-13.67a.37.37 0 11.37-.65L325.5 410a.36.36 0 01.13.51.37.37 0 01-.32.15zM317 416.33a.41.41 0 01-.19-.05l-23.64-13.68a.37.37 0 01-.14-.51.39.39 0 01.52-.13l23.6 13.67a.37.37 0 01.14.51.38.38 0 01-.29.19z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M320.22 400.55h-12.38a.38.38 0 110-.75h12.28l10.95-6a.37.37 0 01.51.14.39.39 0 01-.15.51l-11 6.09a.37.37 0 01-.21.01zM310.33 380.36a.38.38 0 01-.19-.7l34.86-20.6a.38.38 0 01.19-.05h12a.41.41 0 01.19.05l13.45 7.67a.37.37 0 11-.37.64l-13.37-7.61h-11.8l-34.76 20.55a.41.41 0 01-.2.05z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M320.29 374.34a.37.37 0 01-.37-.37v-14.06a.36.36 0 01.19-.32l22.83-12.79a.37.37 0 11.37.65l-22.65 12.68V374a.37.37 0 01-.37.34z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M398.7 353a.45.45 0 01-.19-.05l-31.67-18.45h-23.61l-25.11 14.58a.37.37 0 01-.51-.13.36.36 0 01.13-.51l25.2-14.64a.37.37 0 01.18 0h23.82a.37.37 0 01.18 0l31.77 18.5a.38.38 0 01-.19.7zM373.22 370.25c-2 0-3.64-.93-3.64-2.12s1.6-2.13 3.64-2.13 3.64.94 3.64 2.13-1.6 2.12-3.64 2.12zm0-3.5c-1.71 0-2.9.73-2.9 1.38s1.19 1.37 2.9 1.37 2.89-.72 2.89-1.37-1.19-1.38-2.89-1.38z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M401.22 355.85c-2 0-3.64-.93-3.64-2.12s1.6-2.13 3.64-2.13 3.64.94 3.64 2.13-1.6 2.12-3.64 2.12zm0-3.5c-1.71 0-2.9.72-2.9 1.38s1.19 1.37 2.9 1.37 2.89-.72 2.89-1.37-1.19-1.38-2.89-1.38zM345.69 347.91c-2 0-3.64-.94-3.64-2.13s1.6-2.12 3.64-2.12 3.64.93 3.64 2.12-1.6 2.13-3.64 2.13zm0-3.5c-1.7 0-2.89.72-2.89 1.37s1.19 1.38 2.89 1.38 2.9-.73 2.9-1.38-1.19-1.37-2.9-1.37zM333.54 394.82c-2 0-3.64-.93-3.64-2.12s1.6-2.12 3.64-2.12 3.64.93 3.64 2.12-1.6 2.12-3.64 2.12zm0-3.5c-1.71 0-2.9.73-2.9 1.38s1.19 1.38 2.9 1.38 2.9-.73 2.9-1.38-1.19-1.38-2.9-1.38zM381.88 398.63c-2 0-3.64-.93-3.64-2.12s1.6-2.13 3.64-2.13 3.65.94 3.65 2.13-1.6 2.12-3.65 2.12zm0-3.5c-1.7 0-2.89.72-2.89 1.38s1.19 1.37 2.89 1.37 2.9-.72 2.9-1.37-1.19-1.38-2.9-1.38zM451.2 398.56c-2 0-3.64-.94-3.64-2.13s1.6-2.12 3.64-2.12 3.64.93 3.64 2.12-1.6 2.13-3.64 2.13zm0-3.5c-1.71 0-2.9.72-2.9 1.37s1.19 1.38 2.9 1.38 2.89-.73 2.89-1.38-1.18-1.37-2.89-1.37zM474.26 460.6c-2 0-3.64-.93-3.64-2.12s1.6-2.13 3.64-2.13 3.65.94 3.65 2.13-1.6 2.12-3.65 2.12zm0-3.5c-1.7 0-2.89.73-2.89 1.38s1.19 1.37 2.89 1.37 2.9-.72 2.9-1.37-1.16-1.38-2.9-1.38zM482.85 496.38c-2 0-3.64-.93-3.64-2.12s1.6-2.12 3.64-2.12 3.64.93 3.64 2.12-1.59 2.12-3.64 2.12zm0-3.5c-1.7 0-2.89.73-2.89 1.38s1.19 1.38 2.89 1.38 2.9-.73 2.9-1.38-1.19-1.38-2.9-1.38zM275.05 483.48c-2.05 0-3.65-.94-3.65-2.13s1.6-2.12 3.65-2.12 3.64.93 3.64 2.12-1.6 2.13-3.64 2.13zm0-3.5c-1.71 0-2.9.72-2.9 1.37s1.19 1.38 2.9 1.38 2.89-.73 2.89-1.38-1.19-1.35-2.89-1.35zM278.66 504.86c-2 0-3.64-.93-3.64-2.12s1.6-2.12 3.64-2.12 3.65.93 3.65 2.12-1.6 2.12-3.65 2.12zm0-3.5c-1.7 0-2.89.73-2.89 1.38s1.19 1.38 2.89 1.38 2.9-.73 2.9-1.38-1.19-1.38-2.9-1.38zM215.42 477.71c-2 0-3.64-.93-3.64-2.12s1.6-2.13 3.64-2.13 3.64.94 3.64 2.13-1.59 2.12-3.64 2.12zm0-3.5c-1.7 0-2.89.73-2.89 1.38s1.19 1.37 2.89 1.37 2.9-.72 2.9-1.37-1.19-1.38-2.9-1.38zM128.49 523c-2 0-3.64-.94-3.64-2.13s1.6-2.12 3.64-2.12 3.65.93 3.65 2.12-1.6 2.13-3.65 2.13zm0-3.5c-1.7 0-2.89.72-2.89 1.37s1.19 1.38 2.89 1.38 2.9-.73 2.9-1.38-1.19-1.42-2.9-1.42zM91.21 524c-2 0-3.64-.94-3.64-2.13s1.6-2.12 3.64-2.12 3.64.93 3.64 2.12-1.6 2.13-3.64 2.13zm0-3.5c-1.7 0-2.89.72-2.89 1.37s1.19 1.38 2.89 1.38 2.9-.73 2.9-1.38-1.19-1.35-2.9-1.35zM126 395.13c-2 0-3.64-.93-3.64-2.12s1.6-2.13 3.64-2.13 3.64.94 3.64 2.13-1.64 2.12-3.64 2.12zm0-3.5c-1.71 0-2.9.73-2.9 1.38s1.19 1.37 2.9 1.37 2.89-.72 2.89-1.37-1.23-1.38-2.89-1.38zM91.48 388.19c-2 0-3.64-.93-3.64-2.12s1.6-2.12 3.64-2.12 3.65.93 3.65 2.12-1.6 2.12-3.65 2.12zm0-3.5c-1.7 0-2.89.73-2.89 1.38s1.19 1.38 2.89 1.38 2.9-.73 2.9-1.38-1.19-1.38-2.9-1.38zM116.9 375c-2.05 0-3.65-.93-3.65-2.12s1.6-2.12 3.65-2.12 3.64.93 3.64 2.12-1.6 2.12-3.64 2.12zm0-3.5c-1.71 0-2.9.73-2.9 1.38s1.19 1.37 2.9 1.37 2.89-.72 2.89-1.37-1.19-1.36-2.89-1.36zM74.06 359.52c-2 0-3.64-.93-3.64-2.13s1.6-2.12 3.64-2.12 3.65.93 3.65 2.12-1.6 2.13-3.65 2.13zm0-3.5c-1.7 0-2.89.72-2.89 1.37s1.19 1.38 2.89 1.38 2.9-.72 2.9-1.38-1.19-1.39-2.9-1.39zM53.52 332.49c-2 0-3.64-.94-3.64-2.13s1.6-2.12 3.64-2.12 3.65.93 3.65 2.12-1.6 2.13-3.65 2.13zm0-3.5c-1.7 0-2.89.72-2.89 1.37s1.19 1.38 2.89 1.38 2.9-.73 2.9-1.38-1.19-1.36-2.9-1.36zM72.59 282.5c-2 0-3.64-.93-3.64-2.12s1.6-2.13 3.64-2.13 3.64.93 3.64 2.13-1.59 2.12-3.64 2.12zm0-3.5c-1.7 0-2.89.72-2.89 1.38s1.19 1.37 2.89 1.37 2.9-.72 2.9-1.37-1.19-1.38-2.9-1.38zM193.39 324.32c-2 0-3.65-.93-3.65-2.12s1.6-2.12 3.65-2.12 3.61.92 3.61 2.12-1.57 2.12-3.61 2.12zm0-3.49c-1.71 0-2.9.72-2.9 1.37s1.19 1.38 2.9 1.38 2.89-.73 2.89-1.38-1.19-1.37-2.89-1.37zM258.57 290.94c-2 0-3.64-.93-3.64-2.12s1.6-2.12 3.64-2.12 3.64.93 3.64 2.12-1.6 2.12-3.64 2.12zm0-3.5c-1.71 0-2.9.73-2.9 1.38s1.19 1.38 2.9 1.38 2.89-.73 2.89-1.38-1.19-1.38-2.89-1.38zM197.06 246.32c-2 0-3.64-.93-3.64-2.12s1.6-2.13 3.64-2.13 3.64.93 3.64 2.13-1.6 2.12-3.64 2.12zm0-3.5c-1.7 0-2.89.72-2.89 1.38s1.19 1.37 2.89 1.37 2.9-.72 2.9-1.37-1.19-1.38-2.9-1.38zM205.57 216.57c-2 0-3.64-.94-3.64-2.13s1.6-2.12 3.64-2.12 3.64.93 3.64 2.12-1.6 2.13-3.64 2.13zm0-3.5c-1.71 0-2.9.72-2.9 1.37s1.19 1.38 2.9 1.38 2.89-.73 2.89-1.38-1.19-1.37-2.89-1.37zM295.22 289.58c-2 0-3.64-.94-3.64-2.13s1.6-2.12 3.64-2.12 3.64.93 3.64 2.12-1.6 2.13-3.64 2.13zm0-3.5c-1.71 0-2.89.72-2.89 1.37s1.18 1.38 2.89 1.38 2.9-.73 2.9-1.38-1.19-1.37-2.9-1.37zM410.6 234.13c-2 0-3.64-.94-3.64-2.13s1.6-2.12 3.64-2.12 3.64.93 3.64 2.12-1.6 2.13-3.64 2.13zm0-3.5c-1.71 0-2.9.72-2.9 1.37s1.19 1.38 2.9 1.38 2.89-.73 2.89-1.38-1.18-1.37-2.89-1.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__Desktop-HD-v_2-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__HERO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__IMG_HERO",
    "data-name": "IMG HERO"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path",
    className: "header-section-image_svg__cls-3",
    d: "M63.16 428.53l-7.15-1-27.87 16.34c-7.07-2.16-16.07-1.49-22 2-4.41 2.55-6.14 6.04-5.14 9.37-.77 3.21 1 6.57 5.3 9 7.28 4.12 19.05 4 26.27-.19 3.63-2.11 5.42-4.9 5.39-7.61L37.9 453a5.9 5.9 0 00-.4-2l3-1.71v-2.41h3.93v-2.27h3.93v-2.28h3.94V440h3.93v-2.27h4.24l1.32-.78 1.46-6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-2",
    "data-name": "Path",
    className: "header-section-image_svg__cls-3",
    d: "M22.33 447.48l8.94 5.05 9.12-5.33-.03-2.32-.08.05-.01-.16 4.06-.03-.02-2.29 3.97-.02-.02-2.29 3.97-.02-.02-2.28 3.98-.03-.03-2.29 4.26-.03 1.32-.77 1.46-5.99-.03-2.31-.7 2.21-6.44-.85-33.7 19.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-3",
    "data-name": "Path",
    className: "header-section-image_svg__cls-4",
    d: "M31.27 450.26l9.12-5.38-.11-2.45 4.05-.03-.1-2.31 4.06-.03-.11-2.3 4.06-.02-.1-2.31 4.05-.02-.1-2.31 4.33-.03 1.33-.78 1.45-6.04-7.17-.97-33.7 19.88 8.94 5.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M31.26 450.63a.41.41 0 01-.18-.05l-8.94-5.1a.39.39 0 01-.19-.32.37.37 0 01.19-.32L55.84 425a.42.42 0 01.24 0l7.17 1a.4.4 0 01.26.16.45.45 0 01.05.3l-1.45 6a.33.33 0 01-.17.23l-1.33.79a.41.41 0 01-.19.05h-3.94l.08 1.92a.37.37 0 01-.1.28.37.37 0 01-.27.11h-3.66l.08 1.92a.34.34 0 01-.1.27.36.36 0 01-.27.12h-3.67l.09 1.9a.36.36 0 01-.1.28.45.45 0 01-.27.12h-3.67l.08 1.92a.37.37 0 01-.1.28.39.39 0 01-.27.11h-3.66l.09 2.07a.36.36 0 01-.18.33l-9.13 5.38a.38.38 0 01-.19.09zm-8.19-5.48l8.19 4.68 8.74-5.15-.09-2.24a.34.34 0 01.1-.27.45.45 0 01.27-.12h3.66l-.08-1.92a.37.37 0 01.1-.28.39.39 0 01.27-.11h3.67l-.09-1.91a.34.34 0 01.1-.27.36.36 0 01.27-.12h3.67l-.08-1.92a.36.36 0 01.37-.39h3.66l-.08-1.92a.38.38 0 01.1-.27.36.36 0 01.27-.12h4.23l1.1-.65 1.32-5.48-6.63-.9z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape",
    className: "header-section-image_svg__cls-3",
    d: "M7.27 463.09c7.12 4.16 18.62 4.07 25.68-.19 3.55-2.14 5.3-4.94 5.27-7.69l-.1-3.51-.57.66a11.29 11.29 0 00-4.7-4.71c-7.12-4.16-18.63-4.08-25.69.18s-7.02 11.1.11 15.26zm10.29-6.21c1.85 1.08 1.86 2.86 0 3.95a7.13 7.13 0 01-6.73.05c-1.83-1.07-1.83-2.88 0-3.95a7.22 7.22 0 016.73-.05z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-4",
    "data-name": "Path",
    className: "header-section-image_svg__cls-3",
    d: "M40.49 444.58l4.54-.03-.02-2.24"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-2",
    "data-name": "Shape",
    className: "header-section-image_svg__cls-3",
    d: "M7.27 463.09c7.12 4.16 18.62 4.07 25.68-.19 3.55-2.14 5.3-4.94 5.27-7.69l-.1-3.51-.57.66a11.29 11.29 0 00-4.7-4.71c-7.12-4.16-18.63-4.08-25.69.18s-7.02 11.1.11 15.26zm10.29-6.21c1.85 1.08 1.86 2.86 0 3.95a7.13 7.13 0 01-6.73.05c-1.83-1.07-1.83-2.88 0-3.95a7.22 7.22 0 016.73-.05z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-3",
    "data-name": "Shape",
    className: "header-section-image_svg__cls-3",
    d: "M7.27 463.09c7.12 4.16 18.62 4.07 25.68-.19 3.55-2.14 5.3-4.94 5.27-7.69l-.1-3.51-.57.66a11.29 11.29 0 00-4.7-4.71c-7.12-4.16-18.63-4.08-25.69.18s-7.02 11.1.11 15.26zm10.29-6.21c1.85 1.08 1.86 2.86 0 3.95a7.13 7.13 0 01-6.73.05c-1.83-1.07-1.83-2.88 0-3.95a7.22 7.22 0 016.73-.05z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-4",
    "data-name": "Shape",
    className: "header-section-image_svg__cls-5",
    d: "M7.27 459.68c7.12 4.16 18.62 4.08 25.69-.19s7-11.09-.11-15.25-18.62-4.08-25.69.19-7.02 11.09.11 15.25zm10.29-6.21c1.86 1.09 1.87 2.86 0 3.95a7.2 7.2 0 01-6.68.05c-1.85-1.08-1.87-2.86 0-4a7.24 7.24 0 016.67 0z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M19.91 463.13A25.91 25.91 0 017.07 460c-3.57-2.08-5.55-4.89-5.57-7.91s1.91-5.88 5.46-8c7.16-4.33 18.86-4.41 26.09-.19 3.57 2.08 5.55 4.9 5.57 7.92s-1.92 5.87-5.46 8a26.16 26.16 0 01-13.25 3.31zm.3-21.56a25.36 25.36 0 00-12.84 3.2c-3.3 2-5.1 4.6-5.08 7.33s1.86 5.3 5.18 7.23c7 4.09 18.34 4 25.28-.18 3.29-2 5.09-4.59 5.07-7.32s-1.85-5.3-5.17-7.24a25.21 25.21 0 00-12.44-3.02zm-6 17.09a7.71 7.71 0 01-3.47-.83 2.78 2.78 0 01-1.61-2.34 2.73 2.73 0 011.59-2.31 7.65 7.65 0 017-.11l.1.06a2.49 2.49 0 010 4.64 7.72 7.72 0 01-3.65.89zm.09-5.58a6.94 6.94 0 00-3.19.79 2 2 0 00-1.19 1.62 2 2 0 001.2 1.64 6.84 6.84 0 006.3-.06 2 2 0 001.18-1.62 2 2 0 00-1.13-1.59h-.06a6.79 6.79 0 00-3.15-.78z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-5",
    "data-name": "Shape",
    className: "header-section-image_svg__cls-5",
    d: "M32.86 444.24c-7.13-4.16-18.63-4.08-25.7.19s-7 11.09.11 15.25a21.28 21.28 0 005.36 2.16 27.93 27.93 0 004.26.75c5.66.58 11.72-.47 16.07-3.1 7.04-4.3 7.04-11.09-.1-15.25zm-15.28 13.21a7.23 7.23 0 01-6.68 0c-1.85-1.08-1.87-2.86 0-3.95a7.25 7.25 0 016.73-.05c1.79 1.11 1.8 2.88-.05 4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M19.92 463.14c-1 0-2.05-.05-3.07-.15a29 29 0 01-4.32-.76A21.88 21.88 0 017.07 460c-3.57-2.08-5.55-4.9-5.57-7.92s1.91-5.87 5.46-8c7.16-4.33 18.87-4.41 26.1-.19 3.56 2.09 5.53 4.89 5.56 7.91s-1.91 5.87-5.45 8a26.19 26.19 0 01-13.25 3.34zm.29-21.57a25.36 25.36 0 00-12.84 3.2c-3.3 2-5.1 4.59-5.08 7.33s1.86 5.3 5.18 7.23a20.89 20.89 0 005.26 2.13 28.4 28.4 0 004.2.74c5.78.58 11.69-.56 15.83-3.05 3.29-2 5.09-4.61 5.06-7.33s-1.86-5.29-5.17-7.23a25.18 25.18 0 00-12.44-3.02zm-6 17.11a7.58 7.58 0 01-3.47-.83 2.81 2.81 0 01-1.62-2.34 2.77 2.77 0 011.6-2.31 7.64 7.64 0 017.11-.06 2.77 2.77 0 011.56 2.29 2.85 2.85 0 01-1.58 2.36 7.67 7.67 0 01-3.62.89zm.13-5.6a6.85 6.85 0 00-3.23.81 2 2 0 00-1.19 1.62 2 2 0 001.2 1.64 6.83 6.83 0 006.28 0 2.09 2.09 0 001.19-1.66 2 2 0 00-1.14-1.61 6.79 6.79 0 00-3.13-.8zm3.26 4.37z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__test"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__Group",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-2-2",
    "data-name": "Path-2",
    className: "header-section-image_svg__cls-2",
    d: "M238.26 460.35l-131.92-76.52 131.91-76.5 131.92 76.5-131.91 76.52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-3-2",
    "data-name": "Path-3",
    className: "header-section-image_svg__cls-2",
    d: "M238.26 444.03l-103.79-60.2 103.78-60.19 103.78 60.19-103.77 60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-4-2",
    "data-name": "Path-4",
    className: "header-section-image_svg__cls-2",
    d: "M238.26 444.35a.43.43 0 01-.16-.05l-103.81-60.19a.31.31 0 01-.15-.28.31.31 0 01.15-.27l24.93-14.47a.32.32 0 01.41.12.32.32 0 01-.09.42l-24.49 14.18 103.17 59.83 103.19-59.83-23.33-13.54a.31.31 0 01-.12-.42.33.33 0 01.43-.12l23.81 13.82a.28.28 0 01.15.26.33.33 0 01-.15.28l-103.81 60.19a.49.49 0 01-.16.05z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-5",
    className: "header-section-image_svg__cls-4",
    d: "M233.59 342.79a12.25 12.25 0 0112.15 0l72.47 41.42a1.7 1.7 0 010 2.94L245.14 429a10.79 10.79 0 01-10.77 0l-73.16-41.81a1.69 1.69 0 010-2.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M239.76 430.81a11.19 11.19 0 01-5.58-1.49L161 387.51a2.06 2.06 0 010-3.59l72.37-41.45a12.67 12.67 0 0112.53 0l72.47 41.41a2.09 2.09 0 011 1.8 2.06 2.06 0 01-1 1.79l-73.07 41.85a11.18 11.18 0 01-5.54 1.49zm-6-87.7l-72.36 41.46a1.31 1.31 0 00-.68 1.15 1.33 1.33 0 00.68 1.14l73.16 41.81a10.39 10.39 0 0010.4 0L318 386.83a1.33 1.33 0 000-2.3l-72.47-41.41a11.92 11.92 0 00-11.79 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-6",
    className: "header-section-image_svg__cls-4",
    d: "M233.59 330a12.25 12.25 0 0112.15 0l72.47 41.42a1.7 1.7 0 010 2.94l-73.07 41.85a10.79 10.79 0 01-10.77 0l-73.16-41.81a1.69 1.69 0 010-2.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M239.76 418.06a11.19 11.19 0 01-5.58-1.49L161 374.76a2.06 2.06 0 010-3.59l72.37-41.45a12.67 12.67 0 0112.53 0l72.47 41.41a2.09 2.09 0 011 1.8 2.06 2.06 0 01-1 1.79l-73.07 41.85a11.18 11.18 0 01-5.54 1.49zm-6-87.69l-72.36 41.45a1.31 1.31 0 00-.68 1.15 1.33 1.33 0 00.68 1.14l73.16 41.81a10.39 10.39 0 0010.4 0L318 374.08a1.33 1.33 0 000-2.3l-72.47-41.41a11.92 11.92 0 00-11.76 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-7",
    className: "header-section-image_svg__cls-4",
    d: "M233.59 319.25a12.3 12.3 0 0112.15 0l72.47 41.42a1.7 1.7 0 010 2.94l-73.07 41.85a10.74 10.74 0 01-10.77 0l-73.16-41.81a1.69 1.69 0 010-2.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M239.76 407.27a11.09 11.09 0 01-5.58-1.49L161 364a2.08 2.08 0 01-1.05-1.8 2 2 0 011.05-1.8l72.37-41.45a12.72 12.72 0 0112.53 0l72.47 41.42a2.06 2.06 0 011 1.79 2.09 2.09 0 01-1 1.8L245.3 405.8a11.08 11.08 0 01-5.54 1.47zm-6-87.69L161.4 361a1.32 1.32 0 00-.68 1.15 1.35 1.35 0 00.68 1.15l73.16 41.81a10.44 10.44 0 0010.4 0L318 363.29a1.33 1.33 0 000-2.3l-72.47-41.41a12 12 0 00-11.79 0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__Group-2",
    className: "header-section-image_svg__cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-8",
    className: "header-section-image_svg__cls-8",
    d: "M234 307.56a12.41 12.41 0 0112.21 0L319 348.91a1.69 1.69 0 010 2.94l-73.35 41.76a10.94 10.94 0 01-10.77 0l-73.45-41.76a1.68 1.68 0 010-2.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M240.26 395.42a11.43 11.43 0 01-5.59-1.46l-73.45-41.76a2.08 2.08 0 010-3.64l72.61-41.34a12.82 12.82 0 0112.61 0l72.73 41.34a2.08 2.08 0 010 3.64L245.84 394a11.37 11.37 0 01-5.58 1.42zm-6-87.51l-72.62 41.35a1.27 1.27 0 000 2.24l73.46 41.77a10.63 10.63 0 0010.38 0l73.34-41.76a1.29 1.29 0 000-2.25l-72.74-41.35a12 12 0 00-11.82 0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-9",
    className: "header-section-image_svg__cls-4",
    d: "M233.59 307.48a12.3 12.3 0 0112.15 0l72.47 41.42a1.7 1.7 0 010 2.94l-73.07 41.85a10.74 10.74 0 01-10.77 0l-73.16-41.81a1.69 1.69 0 010-2.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M239.76 395.5a11.09 11.09 0 01-5.58-1.49L161 352.21a2.07 2.07 0 010-3.6l72.37-41.45a12.72 12.72 0 0112.53 0l72.47 41.42a2.07 2.07 0 010 3.59L245.33 394a11.08 11.08 0 01-5.57 1.5zm-6-87.69l-72.36 41.45a1.33 1.33 0 00-.68 1.15 1.35 1.35 0 00.68 1.15l73.16 41.81a10.44 10.44 0 0010.4 0L318 351.52a1.33 1.33 0 000-2.3l-72.47-41.41a12 12 0 00-11.79 0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__Group-3",
    className: "header-section-image_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-10",
    className: "header-section-image_svg__cls-2",
    d: "M135.38 336.11a8 8 0 01-3.92-1l-21-11.68a1.44 1.44 0 010-2.54L130.22 310a9.21 9.21 0 018.82 0l20.51 11.41a1.44 1.44 0 010 2.54l-20.28 11.14a8 8 0 01-3.91 1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-11",
    className: "header-section-image_svg__cls-4",
    d: "M139.31 298.19a8.53 8.53 0 00-8.52 0l-19.74 11.21a1.19 1.19 0 00-.61 1 1.21 1.21 0 00.61 1l21 12a7.55 7.55 0 007.5 0l20.24-11.4a1.21 1.21 0 00.6-1 1.18 1.18 0 00-.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M135.79 324.88a7.88 7.88 0 01-3.94-1.05l-21-12a1.56 1.56 0 010-2.72l19.74-11.21a8.93 8.93 0 018.89 0L160 309.62a1.58 1.58 0 010 2.72l-20.26 11.49a7.85 7.85 0 01-3.95 1.05zm-.74-27.46a8.2 8.2 0 00-4.07 1.09l-19.75 11.21a.84.84 0 00-.41.71.81.81 0 00.41.71l21 12.05a7.2 7.2 0 007.13 0l20.26-11.5a.82.82 0 000-1.42l-20.47-11.76a8.23 8.23 0 00-4.1-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-12",
    className: "header-section-image_svg__cls-4",
    d: "M139.31 289.36a8.53 8.53 0 00-8.52 0l-19.74 11.2a1.21 1.21 0 00-.61 1 1.19 1.19 0 00.61 1l21 12.05a7.5 7.5 0 007.5 0l20.25-11.49a1.18 1.18 0 00.6-1 1.2 1.2 0 00-.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M135.79 316.05a8 8 0 01-3.94-1l-21-12.06a1.56 1.56 0 01-.79-1.35 1.59 1.59 0 01.79-1.36L130.61 289a8.93 8.93 0 018.89 0l20.5 11.8a1.58 1.58 0 01.78 1.36 1.55 1.55 0 01-.78 1.35L139.72 315a7.94 7.94 0 01-3.93 1.05zm-.74-27.45a8.19 8.19 0 00-4.07 1.08l-19.75 11.21a.85.85 0 00-.42.71.84.84 0 00.42.7l21 12.06a7.2 7.2 0 007.13 0l20.26-11.5a.81.81 0 00.41-.7.83.83 0 00-.42-.72l-20.47-11.75a8.22 8.22 0 00-4.09-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-13",
    className: "header-section-image_svg__cls-4",
    d: "M139.31 281.52a8.53 8.53 0 00-8.52 0l-19.74 11.21a1.17 1.17 0 00-.61 1 1.21 1.21 0 00.61 1l21 12a7.55 7.55 0 007.5 0l20.25-11.5a1.19 1.19 0 000-2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M135.79 308.21a7.88 7.88 0 01-3.94-1l-21-12a1.59 1.59 0 01-.79-1.36 1.55 1.55 0 01.8-1.36l19.74-11.21a8.93 8.93 0 018.89 0L160 293a1.55 1.55 0 01.78 1.36 1.59 1.59 0 01-.78 1.36l-20.26 11.49a7.85 7.85 0 01-3.95 1zm-.74-27.46a8.09 8.09 0 00-4.07 1.09l-19.75 11.21a.84.84 0 00-.42.71.87.87 0 00.42.71l21 12a7.15 7.15 0 007.13 0L159.61 295a.84.84 0 00.41-.72.81.81 0 00-.41-.7l-20.48-11.76a8.13 8.13 0 00-4.08-1.07z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__Group-4",
    className: "header-section-image_svg__cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-14",
    className: "header-section-image_svg__cls-8",
    d: "M139.24 272.89a8.53 8.53 0 00-8.47 0L111.12 284a1.15 1.15 0 00-.6 1 1.18 1.18 0 00.6 1L132 297.85a7.49 7.49 0 007.47 0l20.15-11.33a1.18 1.18 0 00.6-1 1.15 1.15 0 00-.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M135.74 299.24a7.94 7.94 0 01-3.93-1l-20.89-11.87a1.56 1.56 0 01-.8-1.36 1.58 1.58 0 01.8-1.37l19.66-11.05a9 9 0 018.86 0l20.39 11.58a1.57 1.57 0 010 2.74l-20.15 11.29a8 8 0 01-3.94 1.04zm-.74-27.07a8.17 8.17 0 00-4 1.07l-19.66 11.05a.79.79 0 00-.39.68.77.77 0 00.39.67l20.89 11.87a7.15 7.15 0 007.08 0l20.16-11.34a.78.78 0 00.4-.67.77.77 0 00-.4-.67l-20.39-11.59a8.17 8.17 0 00-4.08-1.07z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-15",
    className: "header-section-image_svg__cls-4",
    d: "M139.31 273.67a8.53 8.53 0 00-8.52 0l-19.74 11.21a1.21 1.21 0 00-.61 1 1.19 1.19 0 00.61 1l21 12a7.45 7.45 0 007.5 0l20.25-11.49a1.21 1.21 0 00.6-1 1.19 1.19 0 00-.6-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M135.79 300.36a7.88 7.88 0 01-3.94-1.05l-21-12a1.56 1.56 0 010-2.71l19.75-11.22a8.9 8.9 0 018.89 0L160 285.09a1.6 1.6 0 01.78 1.36 1.58 1.58 0 01-.78 1.36l-20.26 11.5a7.85 7.85 0 01-3.95 1.05zm-.74-27.45A8.19 8.19 0 00131 274l-19.77 11.2a.89.89 0 00-.42.72.84.84 0 00.42.7l21 12a7.15 7.15 0 007.13 0l20.26-11.5a.8.8 0 00.4-.71.81.81 0 00-.41-.71L139.13 274a8.22 8.22 0 00-4.08-1.09z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "header-section-image_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-6",
    "data-name": "Shape",
    className: "header-section-image_svg__cls-4",
    d: "M135.42 293.15a.58.58 0 01-.34-.09l-12.55-7.17a.67.67 0 010-1.17l12.55-7.17a.69.69 0 01.68 0l12.55 7.17a.69.69 0 01.33.59.71.71 0 01-.33.58l-12.55 7.17a.69.69 0 01-.34.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M135.41 293.53a1 1 0 01-.54-.16l-12.53-7.16a1.07 1.07 0 01-.52-.9 1 1 0 01.51-.91l12.57-7.17a1 1 0 011 0l12.56 7.18a1.07 1.07 0 01.51.91 1 1 0 01-.5.89l-12.57 7.18a1.13 1.13 0 01-.52.15zm0-15.69a.32.32 0 00-.16 0L122.71 285a.35.35 0 00-.14.27.32.32 0 00.15.26l12.55 7.16a.22.22 0 00.14 0 .33.33 0 00.16 0l12.56-7.17a.3.3 0 00.13-.25.31.31 0 00-.14-.27l-12.55-7.17a.37.37 0 00-.15.01z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__Group-5",
    className: "header-section-image_svg__cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-17",
    className: "header-section-image_svg__cls-2",
    d: "M325.68 474.48a7.6 7.6 0 01-3.84-1l-20.57-12a1.51 1.51 0 010-2.6l49.79-29a8.62 8.62 0 018.67 0l20.1 11.69a1.52 1.52 0 010 2.61l-50.31 29.3a7.66 7.66 0 01-3.84 1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-18",
    className: "header-section-image_svg__cls-4",
    d: "M359.14 420.77a8.24 8.24 0 00-8.34 0l-49.75 29a1.2 1.2 0 00-.58 1 1.21 1.21 0 00.58 1l20.57 11.95a7.24 7.24 0 007.36 0l50.22-29.24a1.21 1.21 0 00.58-1 1.2 1.2 0 00-.58-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M325.3 465.13a7.66 7.66 0 01-3.87-1.05l-20.56-12a1.57 1.57 0 010-2.7l49.75-29a8.61 8.61 0 018.72 0l20.06 11.68a1.57 1.57 0 010 2.7l-50.23 29.25a7.6 7.6 0 01-3.87 1.12zM355 420a7.83 7.83 0 00-4 1.08l-49.75 29a.83.83 0 000 1.42l20.57 11.95a6.87 6.87 0 007 0L379 434.19a.83.83 0 000-1.42l-20-11.68a7.86 7.86 0 00-4-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-19",
    className: "header-section-image_svg__cls-4",
    d: "M359.14 412.92a8.24 8.24 0 00-8.34 0l-49.75 29a1.21 1.21 0 00-.58 1 1.18 1.18 0 00.58 1l20.57 12a7.29 7.29 0 007.36 0l50.22-29.25a1.18 1.18 0 00.58-1 1.21 1.21 0 00-.58-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M325.3 457.28a7.66 7.66 0 01-3.87-1l-20.56-12a1.56 1.56 0 010-2.7l49.74-29a8.61 8.61 0 018.72 0l20.06 11.68a1.57 1.57 0 010 2.7l-50.23 29.25a7.6 7.6 0 01-3.86 1.07zm29.7-45.12a7.74 7.74 0 00-4 1.09l-49.75 29a.81.81 0 000 1.4l20.57 12a6.89 6.89 0 007 0L379 426.34a.83.83 0 000-1.42l-20-11.67a7.77 7.77 0 00-4-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-20",
    className: "header-section-image_svg__cls-4",
    d: "M359.14 405.08a8.24 8.24 0 00-8.34 0l-49.75 29a1.18 1.18 0 00-.58 1 1.21 1.21 0 00.58 1l20.57 12a7.24 7.24 0 007.36 0l50.22-29.24a1.21 1.21 0 00.58-1 1.18 1.18 0 00-.58-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M325.3 449.44a7.57 7.57 0 01-3.87-1.06l-20.56-12a1.57 1.57 0 01-.78-1.35 1.55 1.55 0 01.78-1.34l49.74-29a8.64 8.64 0 018.72 0l20.06 11.67a1.62 1.62 0 01.77 1.36 1.59 1.59 0 01-.77 1.35l-50.23 29.24a7.51 7.51 0 01-3.86 1.13zm29.7-45.12a7.83 7.83 0 00-4 1.08l-49.75 29a.81.81 0 00-.4.7.85.85 0 00.4.71l20.57 12a6.89 6.89 0 007 0L379 418.49a.8.8 0 00.4-.7.83.83 0 00-.4-.71l-20-11.68a7.86 7.86 0 00-4-1.08z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__Group-6",
    className: "header-section-image_svg__cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-21",
    className: "header-section-image_svg__cls-8",
    d: "M359.14 396.47a8.3 8.3 0 00-8.32 0l-49.62 28.68a1.12 1.12 0 000 2L321.77 439a7.33 7.33 0 007.33 0l50.11-29a1.18 1.18 0 000-2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M325.44 440.33a7.8 7.8 0 01-3.87-1L301 427.46a1.53 1.53 0 010-2.65l49.62-28.69a8.71 8.71 0 018.72 0l20.07 11.48a1.58 1.58 0 010 2.74l-50.11 29a7.79 7.79 0 01-3.86.99zM355 395.75a7.87 7.87 0 00-4 1.06l-49.6 28.69a.76.76 0 00-.38.64.78.78 0 00.38.63l20.6 11.85a7 7 0 006.94 0l50.1-29a.79.79 0 00.39-.68.76.76 0 00-.39-.67l-20.07-11.49a7.87 7.87 0 00-3.97-1.03z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-22",
    className: "header-section-image_svg__cls-4",
    d: "M359.14 396.25a8.24 8.24 0 00-8.34 0l-49.75 29a1.17 1.17 0 00-.58 1 1.2 1.2 0 00.58 1l20.57 12a7.29 7.29 0 007.36 0L379.2 410a1.2 1.2 0 00.58-1 1.21 1.21 0 00-.58-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M325.3 440.56a7.66 7.66 0 01-3.87-1.05l-20.56-12a1.6 1.6 0 01-.78-1.35 1.55 1.55 0 01.78-1.3l49.74-29a8.61 8.61 0 018.72 0l20.06 11.63a1.57 1.57 0 010 2.7l-50.23 29.25a7.6 7.6 0 01-3.86 1.12zm29.7-45.07a7.83 7.83 0 00-4 1.08l-49.75 29a.8.8 0 00-.4.67.83.83 0 00.41.7l20.56 11.95a6.87 6.87 0 007 0L379 409.62a.83.83 0 000-1.42l-20-11.63a7.86 7.86 0 00-4-1.08z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "header-section-image_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-2-2",
    "data-name": "Shape-2",
    className: "header-section-image_svg__cls-4",
    d: "M326.39 433.37a.67.67 0 01-.34-.09l-12.55-7.18a.68.68 0 01-.33-.57.68.68 0 01.33-.59l12.55-7.17a.71.71 0 01.69 0l12.55 7.17a.69.69 0 01.32.59.67.67 0 01-.32.57l-12.55 7.18a.73.73 0 01-.35.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M326.39 433.74a1.06 1.06 0 01-.52-.13l-12.55-7.18a1.05 1.05 0 010-1.81l12.55-7.18a1.11 1.11 0 011.06 0l12.55 7.17a1.07 1.07 0 01.52.92 1.06 1.06 0 01-.51.89l-12.55 7.19a1.16 1.16 0 01-.55.13zm0-15.69a.34.34 0 00-.17.05l-12.54 7.16a.32.32 0 00-.15.27.29.29 0 00.15.25l12.55 7.22a.37.37 0 00.34 0l12.53-7.17a.31.31 0 00.14-.25.33.33 0 00-.15-.28l-12.53-7.16a.47.47 0 00-.16-.09z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "header-section-image_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-3-2",
    "data-name": "Shape-3",
    className: "header-section-image_svg__cls-4",
    d: "M352.82 417.68a.66.66 0 01-.33-.09L340 410.42a.67.67 0 01-.34-.58.7.7 0 01.34-.59l12.54-7.17a.71.71 0 01.69 0l12.54 7.17a.66.66 0 010 1.16l-12.54 7.17a.75.75 0 01-.36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M352.82 418.05a1.07 1.07 0 01-.52-.14l-12.54-7.16a1.06 1.06 0 010-1.82l12.55-7.18a1.09 1.09 0 011.05 0l12.55 7.17a1.07 1.07 0 01.52.91 1 1 0 01-.52.9l-12.55 7.18a1.08 1.08 0 01-.53.14zm0-15.69a.33.33 0 00-.17 0l-12.54 7.18a.31.31 0 000 .52l12.55 7.17a.33.33 0 00.14 0 .48.48 0 00.17-.05l12.55-7.17a.31.31 0 00.14-.26.3.3 0 00-.15-.26L353 402.4a.28.28 0 00-.16-.04z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg___-_-Ockam_io",
    "data-name": "- -Ockam.io"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-section-image_svg__img-hero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval",
    className: "header-section-image_svg__cls-11",
    cx: 260.9,
    cy: 332.43,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 261.15 332.12)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-2",
    className: "header-section-image_svg__cls-11",
    cx: 242.8,
    cy: 336.58,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 242.886 336.538)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-3",
    className: "header-section-image_svg__cls-11",
    cx: 217.44,
    cy: 364.54,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 217.279 364.34)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-4",
    className: "header-section-image_svg__cls-11",
    cx: 228.31,
    cy: 328.81,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 228.622 328.615)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-5",
    className: "header-section-image_svg__cls-11",
    cx: 250.04,
    cy: 368.18,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 249.802 368.496)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-6",
    className: "header-section-image_svg__cls-11",
    cx: 271.77,
    cy: 352.13,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 272.064 352.389)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-7",
    className: "header-section-image_svg__cls-11",
    cx: 235.55,
    cy: 360.4,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 235.539 360.573)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-8",
    className: "header-section-image_svg__cls-11",
    cx: 224.7,
    cy: 340.71,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 224.62 340.955)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-9",
    className: "header-section-image_svg__cls-11",
    cx: 253.64,
    cy: 356.27,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 253.804 356.155)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-10",
    className: "header-section-image_svg__cls-11",
    cx: 221.07,
    cy: 352.62,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 221.275 352.65)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-11",
    className: "header-section-image_svg__cls-11",
    cx: 257.28,
    cy: 344.36,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 257.15 344.46)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "header-section-image_svg__Oval-12",
    className: "header-section-image_svg__cls-11",
    cx: 206.57,
    cy: 344.84,
    rx: 1.66,
    ry: 1.14,
    transform: "rotate(-.88 206.36 344.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-25",
    className: "header-section-image_svg__cls-2",
    d: "M263.41 333.72c9.21 2 14 8.36 10.67 14.24a10.62 10.62 0 01-1.63 2.14 3.77 3.77 0 011.49.44 2.15 2.15 0 01.69.55c6.05-6.09 3.2-14-6.33-17.74a28.55 28.55 0 00-4.14-1.24 1.73 1.73 0 01-.75 1.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-2-2-2",
    "data-name": "Path-2-2",
    className: "header-section-image_svg__cls-2",
    d: "M259.77 345.64a17.47 17.47 0 019.58 5.1 4.34 4.34 0 012.43-.68c-2.38-2.86-6.4-5-11.29-6a1.49 1.49 0 01-.72 1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-3-2-2",
    "data-name": "Path-3-2",
    className: "header-section-image_svg__cls-2",
    d: "M260.31 338.51a9.18 9.18 0 01-2.39 3.81 4.5 4.5 0 011.49.44 3.09 3.09 0 01.67.52c2.8-2.75 3.83-6.09 2.84-9.27a3.82 3.82 0 01-1 .35 4.65 4.65 0 01-1.62.09 7 7 0 010 4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-4-2-2",
    "data-name": "Path-4-2",
    className: "header-section-image_svg__cls-2",
    d: "M256.74 355.56a1.39 1.39 0 01-.28 1.7 28.77 28.77 0 0014.15-3.21 4.79 4.79 0 01-1-.36 2.09 2.09 0 01-.91-.83 24.68 24.68 0 01-12 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-5-2",
    className: "header-section-image_svg__cls-2",
    d: "M254.35 354.24a3.31 3.31 0 012.13 1c2.78-2.78 3.77-6.09 2.84-9.28a4.81 4.81 0 01-2.59.45c.75 2.67-.1 5.46-2.38 7.83z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-6-2",
    className: "header-section-image_svg__cls-2",
    d: "M271.45 355.27c.72 6.18-6.66 11.62-16.44 12.17-.64 0-1.26.05-1.88 0a1.29 1.29 0 01.12 1 1.72 1.72 0 01-.4.66h2.29c11.28-.62 19.78-6.86 19-14a8.75 8.75 0 00-.29-1.44 4.85 4.85 0 01-2.6.44 7.53 7.53 0 01.22 1.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-7-2",
    className: "header-section-image_svg__cls-2",
    d: "M255.7 362.63a8 8 0 000-4.8 4.73 4.73 0 01-2.59.44 7.77 7.77 0 01-2.35 7.84 3.51 3.51 0 012.14 1 11 11 0 002.8-4.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-8-2",
    className: "header-section-image_svg__cls-2",
    d: "M236.62 362.32a5.58 5.58 0 01-1.08.12c2.35 2.88 6.41 5 11.27 6.06a1.53 1.53 0 01.69-1.63 17.41 17.41 0 01-9.57-5.15 3.14 3.14 0 01-1.31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-9-2",
    className: "header-section-image_svg__cls-2",
    d: "M238.68 359.72a1.43 1.43 0 01-.3 1.69 28.93 28.93 0 0014.13-3.23 3 3 0 01-1.86-1.19 25.14 25.14 0 01-12 2.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-10-2",
    className: "header-section-image_svg__cls-2",
    d: "M220.55 363.87a1.4 1.4 0 01-.31 1.68 28.6 28.6 0 0014.14-3.22 2.94 2.94 0 01-1.9-1.18 25 25 0 01-11.93 2.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-11-2",
    className: "header-section-image_svg__cls-2",
    d: "M247.06 371c.64-.29 1.25-.59 1.81-.91a2.83 2.83 0 01-1.87-1.17 13.74 13.74 0 01-1.44.7c-8.14 3.57-19.24 2.35-24.77-2.74a10.58 10.58 0 01-.92-1 4.15 4.15 0 01-2.46.7 13.83 13.83 0 001.18 1.24c6.36 5.88 19.11 7.27 28.47 3.16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-12-2",
    className: "header-section-image_svg__cls-2",
    d: "M221.05 354.66c2.39 2.87 6.43 5 11.29 6.07a1.59 1.59 0 01.7-1.63 17.39 17.39 0 01-9.55-5.14 4.41 4.41 0 01-2.44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-13-2",
    className: "header-section-image_svg__cls-2",
    d: "M218.05 358.44a9.52 9.52 0 012.39-3.81 4.08 4.08 0 01-1.48-.44 2.58 2.58 0 01-.67-.51c-2.79 2.74-3.83 6.07-2.84 9.26a4.47 4.47 0 012.57-.44 7 7 0 010-4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-14-2",
    className: "header-section-image_svg__cls-2",
    d: "M213 349.32a14.3 14.3 0 01-4-3.13 4.24 4.24 0 01-2.42.69c2.38 2.87 6.44 5 11.31 6a1.58 1.58 0 01.7-1.62 21.09 21.09 0 01-5.55-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-15-2",
    className: "header-section-image_svg__cls-2",
    d: "M215 363.21c-9.22-2-14-8.4-10.68-14.25a10 10 0 011.64-2.13 4.34 4.34 0 01-1.49-.44 2.07 2.07 0 01-.67-.54c-6.06 6.09-3.22 14 6.33 17.74a28.8 28.8 0 004.13 1.24 1.61 1.61 0 01.74-1.62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-16-2",
    className: "header-section-image_svg__cls-2",
    d: "M221.62 341.37a1.33 1.33 0 01-.12-1 1.86 1.86 0 01.38-.65 28.78 28.78 0 00-14.15 3.22 4.22 4.22 0 011 .34 2.21 2.21 0 01.9.84 24.89 24.89 0 0112-2.72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-17-2",
    className: "header-section-image_svg__cls-2",
    d: "M224 342.72a3.41 3.41 0 01-2.14-1c-2.77 2.77-3.8 6.09-2.86 9.29a4.67 4.67 0 012.6-.44 8.27 8.27 0 012.4-7.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-18-2",
    className: "header-section-image_svg__cls-2",
    d: "M229.49 326.84a3 3 0 011.87 1.19c.46-.25 1-.5 1.43-.72 8.15-3.57 19.25-2.34 24.76 2.75a12.13 12.13 0 01.92 1 4.1 4.1 0 012.45-.7 12.29 12.29 0 00-1.17-1.22c-6.34-5.88-19.1-7.27-28.47-3.17-.61.28-1.2.56-1.79.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-19-2",
    className: "header-section-image_svg__cls-2",
    d: "M222.67 334.32a8 8 0 000 4.8 4.88 4.88 0 012.58-.47c-.78-2.69.07-5.49 2.35-7.84a3.57 3.57 0 01-2.13-1 10.52 10.52 0 00-2.8 4.48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-20-2",
    className: "header-section-image_svg__cls-2",
    d: "M206.9 341.63c-.69-6.19 6.68-11.65 16.49-12.2.61 0 1.23-.05 1.82 0a1.28 1.28 0 01-.12-1 1.93 1.93 0 01.41-.65h-2.29c-11.28.62-19.76 6.86-19 14a8.77 8.77 0 00.3 1.44 4.92 4.92 0 012.56-.44c-.08-.37-.15-.74-.2-1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-21-2",
    className: "header-section-image_svg__cls-2",
    d: "M245.87 335.83a24.81 24.81 0 0111.92-2.75 1.46 1.46 0 01.29-1.68 28.55 28.55 0 00-14.1 3.24 2.84 2.84 0 011.89 1.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-22-2",
    className: "header-section-image_svg__cls-2",
    d: "M241.75 334.63a5.45 5.45 0 011.06-.11c-2.38-2.87-6.41-5-11.27-6.06a1.35 1.35 0 010 .69 1.93 1.93 0 01-.7.92c4.11.9 7.53 2.74 9.57 5.17a3.4 3.4 0 011.34-.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-23-2",
    className: "header-section-image_svg__cls-2",
    d: "M257.35 342.29c-2.41-2.85-6.46-5-11.31-6.05a1.56 1.56 0 01-.73 1.62 17.59 17.59 0 019.56 5.13 4.36 4.36 0 012.48-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-24-2",
    className: "header-section-image_svg__cls-2",
    d: "M239.72 337.21a1.41 1.41 0 01.31-1.67 28.82 28.82 0 00-14.14 3.22 2.86 2.86 0 011.86 1.18 25.26 25.26 0 0112-2.72z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-5-2",
    "data-name": "Path",
    style: {
      isolation: "isolate"
    },
    fill: "url(#header-section-image_svg__linear-gradient)",
    opacity: 0.1,
    d: "M142.66 267.48h-19.3V103.09l19.3-11.57v175.96z"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-13",
    d: "M122.42 107.41h.75V258.4h-.75zM143.99 107.41h.75V258.4h-.75z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-3",
    d: "M125.95 96.06h.5v150.99h-.5z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-7",
    "data-name": "Shape",
    d: "M134.78 240.24a2 2 0 011.58.67 2.32 2.32 0 01.11 3.05 2 2 0 01-1.69.81h-4.4a2.58 2.58 0 01-1.8-.59 2.13 2.13 0 01-.67-1.68c0-1.51.82-2.26 2.47-2.26zm-.67.75h-3.21c-1.27 0-1.9.5-1.9 1.51s.63 1.52 1.9 1.52h3.21a2 2 0 001.23-.39 1.43 1.43 0 00.52-1.13 1.35 1.35 0 00-.52-1.11 1.84 1.84 0 00-1.23-.4z",
    fill: "url(#header-section-image_svg__linear-gradient-2)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-8",
    "data-name": "Shape",
    d: "M134.78 230.05a2 2 0 011.58.68 2.22 2.22 0 01.63 1.57 2.31 2.31 0 01-.52 1.46 2.09 2.09 0 01-1.69.8h-4.39a2.6 2.6 0 01-1.8-.6 2.07 2.07 0 01-.67-1.66 2 2 0 01.64-1.71 2.24 2.24 0 011.83-.54zm-.67.74h-3.2c-1.27 0-1.9.5-1.9 1.51s.63 1.5 1.9 1.5h3.2a1.92 1.92 0 001.23-.38 1.38 1.38 0 00.52-1.12 1.31 1.31 0 00-.52-1.1 1.87 1.87 0 00-1.23-.41z",
    fill: "url(#header-section-image_svg__linear-gradient-3)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-6-2",
    "data-name": "Path",
    d: "M135.48 223.22a2.14 2.14 0 011 .22.78.78 0 01.5.66h-8v.24h-.2a.49.49 0 00-.3-.36 1.15 1.15 0 00-.55-.17v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-4)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-7-2",
    "data-name": "Path",
    d: "M135.48 217.53a2.27 2.27 0 011 .23.75.75 0 01.5.65h-8v.26h-.2a.47.47 0 00-.3-.36 1.28 1.28 0 00-.55-.18v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-5)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-8-2",
    "data-name": "Path",
    d: "M135.48 213a2.26 2.26 0 011 .22.78.78 0 01.5.66h-8v.26h-.2a.47.47 0 00-.3-.36 1.16 1.16 0 00-.55-.18v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-6)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-9-2",
    "data-name": "Path",
    d: "M135.48 206.18a2.26 2.26 0 011 .22.78.78 0 01.5.66h-8v.26h-.2a.48.48 0 00-.3-.37 1.11 1.11 0 00-.55-.17v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-7)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-10-2",
    "data-name": "Path",
    d: "M135.48 200.5a2.27 2.27 0 011 .23.75.75 0 01.5.66h-8v.25h-.2a.47.47 0 00-.3-.36 1 1 0 00-.55-.18v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-8)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-9",
    "data-name": "Shape",
    d: "M134.78 191.45a2 2 0 011.58.68 2.27 2.27 0 01.63 1.57 2.3 2.3 0 01-.52 1.45 2.05 2.05 0 01-1.69.81h-4.39a2.64 2.64 0 01-1.8-.59 2.13 2.13 0 01-.67-1.67 2 2 0 01.64-1.71 2.24 2.24 0 011.83-.54zm-.67.75h-3.2c-1.27 0-1.9.5-1.9 1.5s.63 1.5 1.9 1.5h3.2a2 2 0 001.23-.38 1.38 1.38 0 00.52-1.12 1.3 1.3 0 00-.52-1.1 1.93 1.93 0 00-1.23-.4z",
    fill: "url(#header-section-image_svg__linear-gradient-9)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-10",
    "data-name": "Shape",
    d: "M134.78 182.37a2 2 0 011.58.67 2.29 2.29 0 01.11 3 2.05 2.05 0 01-1.69.81h-4.39a2.6 2.6 0 01-1.8-.6 2.11 2.11 0 01-.67-1.66 2 2 0 01.64-1.71 2.24 2.24 0 011.83-.54zm-.67.75h-3.2c-1.27 0-1.9.5-1.9 1.5s.63 1.49 1.9 1.49h3.2a1.93 1.93 0 001.23-.37 1.38 1.38 0 00.52-1.12 1.32 1.32 0 00-.52-1.11 1.87 1.87 0 00-1.23-.39z",
    fill: "url(#header-section-image_svg__linear-gradient-10)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-11",
    "data-name": "Shape",
    d: "M134.78 173.28a2.06 2.06 0 011.58.68 2.27 2.27 0 01.63 1.57 2.31 2.31 0 01-.52 1.46 2.05 2.05 0 01-1.69.81h-4.39a2.6 2.6 0 01-1.8-.6 2.12 2.12 0 01-.67-1.67 2 2 0 01.64-1.7 2.25 2.25 0 011.83-.55zm-.67.76h-3.2c-1.27 0-1.9.5-1.9 1.49s.63 1.5 1.9 1.5h3.2a1.93 1.93 0 001.23-.37 1.4 1.4 0 00.52-1.13 1.31 1.31 0 00-.52-1.1 1.87 1.87 0 00-1.23-.39z",
    fill: "url(#header-section-image_svg__linear-gradient-11)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-12",
    "data-name": "Shape",
    d: "M134.78 165.34a2 2 0 011.58.67 2.29 2.29 0 01.11 3 2.05 2.05 0 01-1.69.81h-4.39a2.64 2.64 0 01-1.8-.59 2.13 2.13 0 01-.67-1.67 2 2 0 01.64-1.71 2.24 2.24 0 011.83-.54zm-.67.75h-3.2c-1.27 0-1.9.5-1.9 1.5s.63 1.5 1.9 1.5h3.2a2 2 0 001.23-.38 1.38 1.38 0 00.52-1.12 1.3 1.3 0 00-.52-1.1 1.88 1.88 0 00-1.23-.4z",
    fill: "url(#header-section-image_svg__linear-gradient-12)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-11-2",
    "data-name": "Path",
    d: "M135.48 158.5a2.26 2.26 0 011 .22.78.78 0 01.5.66h-8v.26h-.2a.48.48 0 00-.3-.37 1.11 1.11 0 00-.55-.17v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-13)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-13",
    "data-name": "Shape",
    d: "M134.78 149.44a2.06 2.06 0 011.58.68 2.27 2.27 0 01.63 1.57 2.31 2.31 0 01-.52 1.46 2.05 2.05 0 01-1.69.81h-4.39a2.6 2.6 0 01-1.8-.6 2.12 2.12 0 01-.67-1.67 2 2 0 01.64-1.7 2.25 2.25 0 011.83-.55zm-.67.76h-3.2c-1.27 0-1.9.5-1.9 1.49s.63 1.5 1.9 1.5h3.2a1.93 1.93 0 001.23-.37 1.4 1.4 0 00.52-1.13 1.31 1.31 0 00-.52-1.1 1.87 1.87 0 00-1.23-.39z",
    fill: "url(#header-section-image_svg__linear-gradient-14)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-12-2",
    "data-name": "Path",
    d: "M135.48 144.88a2.14 2.14 0 011 .22.78.78 0 01.5.66h-8v.24h-.2a.49.49 0 00-.3-.36 1 1 0 00-.55-.17v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-15)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-14",
    "data-name": "Shape",
    d: "M134.78 134.68a2.06 2.06 0 011.58.68 2.29 2.29 0 01.11 3 2.05 2.05 0 01-1.69.81h-4.39a2.6 2.6 0 01-1.8-.6 2.11 2.11 0 01-.67-1.66 2 2 0 01.64-1.71 2.28 2.28 0 011.83-.55zm-.67.76h-3.2c-1.27 0-1.9.5-1.9 1.5s.63 1.49 1.9 1.49h3.2a1.93 1.93 0 001.23-.37 1.38 1.38 0 00.52-1.12 1.32 1.32 0 00-.52-1.11 1.87 1.87 0 00-1.23-.42z",
    fill: "url(#header-section-image_svg__linear-gradient-16)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-13-2",
    "data-name": "Path",
    d: "M135.48 129a2.27 2.27 0 011 .23.75.75 0 01.5.66h-8v.25h-.2a.47.47 0 00-.3-.36 1 1 0 00-.55-.18v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-17)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-15",
    "data-name": "Shape",
    d: "M134.78 121.06a2.06 2.06 0 011.58.68 2.28 2.28 0 01.11 3 2 2 0 01-1.69.81h-4.39a2.59 2.59 0 01-1.8-.59 2.13 2.13 0 01-.67-1.67 2 2 0 01.64-1.7 2.21 2.21 0 011.83-.55zm-.67.76h-3.2c-1.27 0-1.9.49-1.9 1.49s.63 1.5 1.9 1.5h3.2a1.93 1.93 0 001.23-.38 1.36 1.36 0 00.52-1.12 1.31 1.31 0 00-.52-1.1 1.93 1.93 0 00-1.23-.38z",
    fill: "url(#header-section-image_svg__linear-gradient-18)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-14-2",
    "data-name": "Path",
    d: "M135.48 114.23a2.14 2.14 0 011 .22.76.76 0 01.5.66h-8v.25h-.2a.49.49 0 00-.3-.36 1 1 0 00-.55-.18v-.59z",
    fill: "url(#header-section-image_svg__linear-gradient-19)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-15-2",
    "data-name": "Path",
    d: "M135.48 108.55a2.14 2.14 0 011 .22.78.78 0 01.5.66h-8v.25h-.2a.49.49 0 00-.3-.36 1.11 1.11 0 00-.55-.17v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-20)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-13",
    d: "M445.67 361.73a2.59 2.59 0 01-1.32-.35l-29.57-17a1 1 0 01-.51-.88 1 1 0 01.51-.89l30.9-17.61h.32l.09.05 30.69 17.61a1 1 0 01.51.88 1 1 0 01-.51.89L447 361.39a2.68 2.68 0 01-1.33.34zm-.95-1a1.92 1.92 0 001.9 0l29.78-16.95a.27.27 0 000-.47l-30.57-17.54-30.68 17.53a.27.27 0 000 .47z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-36",
    style: {
      isolation: "isolate"
    },
    opacity: 0.2,
    fill: "#52c7ea",
    d: "M444.65 356.03l-21.58-13.05 21.58-13.06 21.56 13.06-21.56 13.05z"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-38",
    className: "header-section-image_svg__cls-4",
    d: "M444.64 339l-21.57-13.05v-24.33l21.57 11.84V339z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M444.64 339.38a.33.33 0 01-.19-.06l-21.57-13.05a.36.36 0 01-.18-.32v-24.33a.38.38 0 01.18-.32.38.38 0 01.37 0l21.57 11.84a.37.37 0 01.19.33V339a.38.38 0 01-.37.38zm-21.2-13.64l20.83 12.6v-24.66l-20.83-11.43z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-39",
    className: "header-section-image_svg__cls-4",
    d: "M466.21 326.52L444.64 339v-24.97l21.57-12.49v24.98z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M444.64 339.38a.45.45 0 01-.19-.05.39.39 0 01-.18-.33v-25a.37.37 0 01.18-.32L466 301.22a.37.37 0 01.56.32v25a.38.38 0 01-.18.32l-21.57 12.49a.45.45 0 01-.17.03zm.37-25.14v24.12l20.83-12.06v-24.11zm21.2 12.28z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-40",
    className: "header-section-image_svg__cls-4",
    d: "M444.65 314.68l-21.58-13.06 21.58-13.06 21.56 12.98-21.56 13.14z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M444.65 315.05a.33.33 0 01-.19-.06l-21.58-13.05a.37.37 0 010-.64l21.58-13.05a.35.35 0 01.38 0l21.56 13a.37.37 0 010 .64L444.84 315a.33.33 0 01-.19.05zm-20.86-13.43l20.86 12.62 20.84-12.7L444.65 289z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Rectangle",
    style: {
      isolation: "isolate"
    },
    fill: "url(#header-section-image_svg__linear-gradient-21)",
    opacity: 0.1,
    d: "M436.69 116.5h17.03v162.34h-17.03z"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-13",
    d: "M435.75 133.52h.75v137.36h-.75zM455.05 133.52h.75v137.36h-.75z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-3",
    d: "M439.28 123.31h.5v137.36h-.5z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-16",
    "data-name": "Path",
    d: "M447.86 262.94a1.57 1.57 0 01.88.23.74.74 0 01.44.66h-7v.25H442a.43.43 0 00-.25-.36.86.86 0 00-.49-.18v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-22)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-16",
    "data-name": "Shape",
    d: "M447.25 253.86a1.69 1.69 0 011.37.68 2.37 2.37 0 01.56 1.58 2.6 2.6 0 01-.45 1.47 1.71 1.71 0 01-1.48.81h-3.85a2.14 2.14 0 01-1.58-.59 2.29 2.29 0 01-.58-1.69c0-1.51.72-2.26 2.16-2.26zm-.59.75h-2.8c-1.11 0-1.67.51-1.67 1.51s.56 1.52 1.67 1.52h2.8a1.63 1.63 0 001-.36 1.51 1.51 0 00.46-1.14 1.46 1.46 0 00-.46-1 1.51 1.51 0 00-1-.48z",
    fill: "url(#header-section-image_svg__linear-gradient-23)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-17",
    "data-name": "Shape",
    d: "M447.25 244.78a1.69 1.69 0 011.37.68 2.37 2.37 0 01.56 1.58 2.6 2.6 0 01-.45 1.47 1.73 1.73 0 01-1.48.81h-3.85a2.11 2.11 0 01-1.58-.6 2.25 2.25 0 01-.58-1.68c0-1.51.72-2.26 2.16-2.26zm-.59.75h-2.8c-1.11 0-1.67.51-1.67 1.51s.56 1.51 1.67 1.51h2.8a1.51 1.51 0 001.08-.38 1.53 1.53 0 000-2.19 1.55 1.55 0 00-1.08-.45z",
    fill: "url(#header-section-image_svg__linear-gradient-24)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-17-2",
    "data-name": "Path",
    d: "M447.86 239.1a1.65 1.65 0 01.88.23.74.74 0 01.44.67h-7v.24H442a.46.46 0 00-.25-.36 1 1 0 00-.49-.18v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-25)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-18-2",
    "data-name": "Path",
    d: "M447.86 234.56a1.57 1.57 0 01.88.23.74.74 0 01.44.66h-7v.25H442a.45.45 0 00-.25-.36.86.86 0 00-.49-.18v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-26)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-19-2",
    "data-name": "Path",
    d: "M447.86 228.89a1.66 1.66 0 01.88.21.76.76 0 01.44.67h-7v.23H442a.44.44 0 00-.25-.36.84.84 0 00-.49-.18v-.59z",
    fill: "url(#header-section-image_svg__linear-gradient-27)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-20-2",
    "data-name": "Path",
    d: "M447.86 223.21a1.65 1.65 0 01.88.22.76.76 0 01.44.66h-7v.25H442a.48.48 0 00-.25-.36.93.93 0 00-.49-.17v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-28)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-21-2",
    "data-name": "Path",
    d: "M447.86 218.67a1.65 1.65 0 01.88.22.76.76 0 01.44.66h-7v.25H442a.44.44 0 00-.25-.36.91.91 0 00-.49-.18v-.59z",
    fill: "url(#header-section-image_svg__linear-gradient-29)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-18",
    "data-name": "Shape",
    d: "M447.24 210.76a1.7 1.7 0 011.38.68 2.34 2.34 0 01.56 1.57 2.51 2.51 0 01-.45 1.44 1.75 1.75 0 01-1.49.81h-3.86a2.1 2.1 0 01-1.54-.61 2.19 2.19 0 01-.59-1.65 2.09 2.09 0 01.56-1.71 1.81 1.81 0 011.61-.54zm-.59.74h-2.81c-1.11 0-1.67.5-1.67 1.51s.56 1.5 1.67 1.5h2.81a1.6 1.6 0 001.08-.39 1.44 1.44 0 00.46-1.11 1.38 1.38 0 00-.46-1.1 1.47 1.47 0 00-1.08-.4z",
    fill: "url(#header-section-image_svg__linear-gradient-30)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-19",
    "data-name": "Shape",
    d: "M447.25 202.8a1.71 1.71 0 011.38.68 2.4 2.4 0 01.55 1.58 2.51 2.51 0 01-.45 1.44 1.7 1.7 0 01-1.48.81h-3.84a2.14 2.14 0 01-1.58-.59 2.3 2.3 0 01-.58-1.66 2.11 2.11 0 01.56-1.72 1.79 1.79 0 011.6-.54zm-.59.76h-2.79c-1.11 0-1.67.49-1.67 1.5s.56 1.5 1.67 1.5h2.79a1.55 1.55 0 001.08-.39 1.48 1.48 0 00.46-1.11 1.45 1.45 0 00-.46-1.11 1.48 1.48 0 00-1.08-.36z",
    fill: "url(#header-section-image_svg__linear-gradient-31)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-20",
    "data-name": "Shape",
    d: "M447.25 193.69a1.69 1.69 0 011.37.68 2.38 2.38 0 01.56 1.59 2.65 2.65 0 01-.45 1.47 1.7 1.7 0 01-1.48.8h-3.85a2.1 2.1 0 01-1.58-.59 2.32 2.32 0 01-.58-1.68c0-1.52.72-2.27 2.16-2.27zm-.59.75h-2.8c-1.11 0-1.67.51-1.67 1.52s.56 1.51 1.67 1.51h2.8a1.58 1.58 0 001-.38 1.52 1.52 0 00.46-1.13 1.45 1.45 0 00-.46-1.11 1.56 1.56 0 00-1-.41z",
    fill: "url(#header-section-image_svg__linear-gradient-32)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-21",
    "data-name": "Shape",
    d: "M447.25 186.91a1.71 1.71 0 011.38.68 2.41 2.41 0 01.55 1.56 2.57 2.57 0 01-.45 1.46 1.72 1.72 0 01-1.48.81h-3.84a2.1 2.1 0 01-1.58-.6 2.24 2.24 0 01-.58-1.67 2.1 2.1 0 01.56-1.7 1.79 1.79 0 011.6-.54zm-.59.74h-2.79c-1.11 0-1.67.51-1.67 1.5s.56 1.51 1.67 1.51h2.79a1.52 1.52 0 001.08-.39 1.47 1.47 0 00.46-1.12 1.42 1.42 0 00-.46-1.05 1.53 1.53 0 00-1.08-.45z",
    fill: "url(#header-section-image_svg__linear-gradient-33)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-22-2",
    "data-name": "Path",
    d: "M447.86 181.21a1.56 1.56 0 01.88.22.75.75 0 01.44.66h-7v.25H442a.44.44 0 00-.25-.36.84.84 0 00-.49-.18v-.59z",
    fill: "url(#header-section-image_svg__linear-gradient-34)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-22",
    "data-name": "Shape",
    d: "M447.25 172.15a1.71 1.71 0 011.38.68 2.43 2.43 0 01.55 1.56 2.57 2.57 0 01-.45 1.46 1.72 1.72 0 01-1.48.81h-3.84a2.1 2.1 0 01-1.58-.6 2.24 2.24 0 01-.58-1.67 2.1 2.1 0 01.56-1.7 1.79 1.79 0 011.6-.54zm-.59.74h-2.79c-1.11 0-1.67.51-1.67 1.5s.56 1.52 1.67 1.52h2.79a1.62 1.62 0 001.08-.39 1.51 1.51 0 00.46-1.13 1.42 1.42 0 00-.46-1 1.53 1.53 0 00-1.08-.43z",
    fill: "url(#header-section-image_svg__linear-gradient-35)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-23",
    "data-name": "Path",
    d: "M447.86 168.72a1.65 1.65 0 01.88.22.76.76 0 01.44.66h-7v.25H442a.44.44 0 00-.25-.36.91.91 0 00-.49-.18v-.59z",
    fill: "url(#header-section-image_svg__linear-gradient-36)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-23",
    "data-name": "Shape",
    d: "M447.25 159.64a1.68 1.68 0 011.37.68 2.4 2.4 0 01.56 1.57 2.6 2.6 0 01-.45 1.47 1.71 1.71 0 01-1.48.81h-3.85a2.07 2.07 0 01-1.58-.6 2.25 2.25 0 01-.58-1.68c0-1.51.72-2.25 2.16-2.25zm-.59.74h-2.8c-1.11 0-1.67.51-1.67 1.51s.56 1.52 1.67 1.52h2.8a1.52 1.52 0 001.08-.39 1.49 1.49 0 00.46-1.13 1.42 1.42 0 00-.46-1 1.52 1.52 0 00-1.08-.46z",
    fill: "url(#header-section-image_svg__linear-gradient-37)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-24",
    "data-name": "Path",
    d: "M447.86 154a1.76 1.76 0 01.88.21.78.78 0 01.44.67h-7v.25H442a.46.46 0 00-.25-.36.91.91 0 00-.49-.18V154z",
    fill: "url(#header-section-image_svg__linear-gradient-38)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Shape-24",
    "data-name": "Shape",
    d: "M447.25 146a1.66 1.66 0 011.37.69 2.34 2.34 0 01.56 1.57 2.63 2.63 0 01-.45 1.47 1.73 1.73 0 01-1.48.81h-3.85a2.11 2.11 0 01-1.58-.6 2.25 2.25 0 01-.58-1.68c0-1.51.72-2.26 2.16-2.26zm-.59.75h-2.8c-1.11 0-1.67.51-1.67 1.51s.56 1.52 1.67 1.52h2.8a1.57 1.57 0 001.08-.39 1.51 1.51 0 00.46-1.13 1.41 1.41 0 00-.46-1.05 1.48 1.48 0 00-1.08-.48z",
    fill: "url(#header-section-image_svg__linear-gradient-39)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-25-2",
    "data-name": "Path",
    d: "M447.86 141.5a1.66 1.66 0 01.88.21.78.78 0 01.44.67h-7v.23H442a.43.43 0 00-.25-.36.92.92 0 00-.49-.19v-.59z",
    fill: "url(#header-section-image_svg__linear-gradient-40)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-26",
    "data-name": "Path",
    d: "M447.86 135.8a1.65 1.65 0 01.88.22.74.74 0 01.44.67h-7v.24H442a.46.46 0 00-.25-.36.93.93 0 00-.49-.17v-.6z",
    fill: "url(#header-section-image_svg__linear-gradient-41)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-27",
    "data-name": "Path",
    fill: "url(#header-section-image_svg__linear-gradient-42)",
    d: "M437.83 116.5l7.94-7.95 17.03.04-7.91 7.91h-17.06z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-28",
    "data-name": "Path",
    className: "header-section-image_svg__cls-3",
    d: "M375.39 53.24l28-16.14c4.18-2.46 10-2.15 16.44 1.53a36.33 36.33 0 016.07 4.46l11.29-6.46c6.2-4.33 15.18-4.14 25.19 1.59 12.64 7.22 23.63 21.46 29.48 36.53a14 14 0 016.37 2c8.25 4.72 14.94 16.21 14.94 25.65v.59a18.28 18.28 0 017.69 2.54c10.55 6 19.11 20.72 19.11 32.8 0 6-2.11 10.2-5.51 12.21h-.09l-27.67 15.92-6-28.8-80.84-46.25c-10.33-5.85-19.07-18.67-22-31z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-29",
    "data-name": "Path",
    className: "header-section-image_svg__cls-5",
    d: "M392.74 54.62a40.81 40.81 0 0110.09 8.52c4.23-13.6 17.13-17.82 32.4-9 12.62 7.3 23.59 21.66 29.49 36.86a13.67 13.67 0 016.36 2c8.24 4.75 14.91 16.34 14.91 25.86v.59a18.06 18.06 0 017.68 2.58c10.54 6.09 19.08 20.9 19.08 33.08s-8.54 17.12-19.08 11l-100.93-58.24c-12.71-7.35-23-25.23-23-39.93s10.26-20.67 23-13.32z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M502.19 169.1a17.67 17.67 0 01-8.7-2.67l-100.94-58.24c-12.8-7.4-23.21-25.46-23.21-40.25 0-7.26 2.47-12.68 6.94-15.26s10.38-2 16.64 1.62a41 41 0 019.75 8.1c2-5.93 5.68-10.09 10.68-12 6.18-2.41 14-1.18 22.05 3.47 12.1 7 23.41 21.07 29.57 36.81a14.17 14.17 0 016.29 2c8.32 4.8 15.1 16.55 15.1 26.18v.26a18.6 18.6 0 017.5 2.59c10.61 6.14 19.26 21.12 19.26 33.4 0 6-2.06 10.54-5.79 12.69a10.11 10.11 0 01-5.14 1.3zM382.46 51.84a11.45 11.45 0 00-5.81 1.49c-4.23 2.44-6.56 7.63-6.56 14.61 0 14.55 10.24 32.32 22.83 39.61l100.94 58.24c5 2.87 9.63 3.35 13.11 1.34s5.41-6.3 5.41-12c0-12-8.48-26.73-18.89-32.75a17.64 17.64 0 00-7.49-2.58.38.38 0 01-.34-.38v-.59c0-9.39-6.61-20.85-14.73-25.54a13.32 13.32 0 00-6.19-1.91.39.39 0 01-.33-.24c-6.12-15.68-17.36-29.73-29.41-36.67-7.84-4.53-15.44-5.74-21.41-3.41-4.95 1.93-8.56 6.15-10.44 12.19a.39.39 0 01-.28.26.37.37 0 01-.36-.12 40.32 40.32 0 00-10-8.45 20.55 20.55 0 00-10.05-3.1z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-30",
    "data-name": "Path",
    className: "header-section-image_svg__cls-3",
    d: "M184.67 33.14l-19.11-10.76c-2.86-1.65-6.85-1.45-11.22 1a25.18 25.18 0 00-4.15 2.95L142.48 22c-4.24-2.88-10.37-2.76-17.21 1.06-8.63 4.82-16.16 14.3-20.14 24.34a9.66 9.66 0 00-4.34 1.33c-5.64 3.15-10.21 10.82-10.21 17.09v.39a12.59 12.59 0 00-5.25 1.7c-7.2 4-13 13.77-13 21.85 0 4 1.44 6.8 3.77 8.14h.06L95 108.55l4.12-19.19 55.17-30.79c7.05-3.93 13-12.44 15-20.65z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-31",
    "data-name": "Path",
    className: "header-section-image_svg__cls-5",
    d: "M173.3 33.62a28.45 28.45 0 00-6.92 5.68c-3-9.06-11.87-11.91-22.37-5.95-8.72 4.86-16.32 14.43-20.34 24.57a9.62 9.62 0 00-4.44 1.27c-5.69 3.18-10.31 10.92-10.31 17.24v.39a12.94 12.94 0 00-5.3 1.72c-7.27 4.06-13.18 13.9-13.18 22s5.94 11.41 13.18 7.35l69.68-38.78c8.79-4.89 15.91-16.81 15.91-26.61s-7.12-13.77-15.91-8.88z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M97.73 110.07a7.3 7.3 0 01-3.74-1c-2.53-1.48-3.92-4.5-3.92-8.5 0-8.22 6-18.26 13.37-22.37a13.25 13.25 0 015.11-1.73v-.06c0-6.46 4.71-14.33 10.5-17.57a10 10 0 014.36-1.3c4.21-10.47 12-19.86 20.42-24.54 5.59-3.17 11-4 15.38-2.32a12.7 12.7 0 017.31 7.88 28.71 28.71 0 016.59-5.28c4.45-2.48 8.63-2.83 11.77-1s4.69 5.4 4.69 10.19c0 9.91-7.22 22-16.1 26.94l-69.67 38.82a12.64 12.64 0 01-6.07 1.84zm56.74-79.47a21.27 21.27 0 00-10.28 3.07c-8.32 4.64-16.05 14-20.17 24.39a.38.38 0 01-.34.23 9.44 9.44 0 00-4.27 1.22c-5.58 3.12-10.11 10.71-10.11 16.92v.4a.38.38 0 01-.34.37 12.59 12.59 0 00-5.15 1.66c-7.17 4-13 13.75-13 21.73 0 3.73 1.26 6.52 3.55 7.86s5.61 1.1 9.07-.84l69.68-38.82c8.66-4.83 15.72-16.62 15.72-26.29 0-4.52-1.54-7.9-4.33-9.54s-6.81-1.35-11 1a27.83 27.83 0 00-6.82 5.6.4.4 0 01-.36.12.39.39 0 01-.28-.25c-1.29-4-3.74-6.73-7.08-8a12.4 12.4 0 00-4.49-.83z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-13",
    d: "M90.22 491.5a12.07 12.07 0 01-5.68-1.41l-30.43-17.34c-1.7-1-2.64-2.31-2.64-3.74s.94-2.78 2.64-3.75l30.42-17.38a13.2 13.2 0 0111.81 0l30.44 17.36c1.7 1 2.63 2.31 2.63 3.75s-.93 2.77-2.63 3.74l-30.42 17.36a12.09 12.09 0 01-5.92 1.41zm.23-44.27a12.49 12.49 0 00-5.57 1.31l-30.4 17.37a3.77 3.77 0 00-2.26 3.1c0 1.16.8 2.26 2.26 3.1l30.42 17.33a11.42 11.42 0 005.53 1.31 11.29 11.29 0 005.57-1.32l30.41-17.34c1.45-.84 2.26-1.94 2.26-3.1a3.81 3.81 0 00-2.26-3.1L96 448.53a12.35 12.35 0 00-5.55-1.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "header-section-image_svg__cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-32",
    "data-name": "Path",
    className: "header-section-image_svg__cls-4",
    d: "M129 462v-10.19l-1.89-1c-.53 3.16-4.32 5.25-7.5 5.68L98 469l-9.43 3.35L58.55 457l.73-.38c-2.57-1.18-4-3.88-5.34-6.34l-2 1.19-1.2.33v10.31c0 1.31.88 2.63 2.64 3.63l30.13 17.09a14.32 14.32 0 0012.79 0l30.13-17.09c1.73-1 2.61-2.27 2.64-3.57V462z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M89.87 484.68a14.72 14.72 0 01-6.56-1.53L53.17 466c-1.83-1-2.83-2.43-2.83-4v-10.5l1.42-.4 2.31-1.36.47.82c1.28 2.29 2.61 4.65 4.89 5.7l.69.32-.76.4 29.28 14.94 9.27-3.29 21.65-12.47c3.12-.42 6.69-2.45 7.18-5.37l.08-.5 2.55 1.29v10.37a1 1 0 010 .24 4.8 4.8 0 01-2.83 3.85l-30.12 17.1a14.79 14.79 0 01-6.55 1.54zm-38.79-32.62v10c0 1.24.87 2.41 2.45 3.3l30.13 17.1a14.08 14.08 0 0012.45 0l30.1-17.09a4.15 4.15 0 002.45-3.15V452l-1.26-.64c-.82 3-4.44 5-7.63 5.49l-21.55 12.46-9.64 3.42L57.73 457l.74-.39c-2.1-1.25-3.36-3.5-4.58-5.67l-.09-.16-1.79 1z"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-4",
    d: "M127.15 445.15c-.53 3.28-4.32 5.44-7.5 5.89l-21.58 12.85-9.42 3.48-30.07-15.81.7-.41c-2.57-1.23-4-4-5.34-6.57l-2 1.23-1.2.34v7.13c0 1.37.88 2.73 2.64 3.76l30.13 17.77a13.83 13.83 0 007 1.52 12.72 12.72 0 006.31-1.44l29.69-17.52a4.54 4.54 0 002.6-3.65v-7.53z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M90.86 476.74h-.43a.35.35 0 01-.11 0 14.24 14.24 0 01-7-1.57l-30.16-17.81c-1.82-1.06-2.82-2.51-2.82-4.08v-7.13a.37.37 0 01.27-.36l1.15-.32 2-1.21a.37.37 0 01.29 0 .38.38 0 01.23.18l.27.5c1.29 2.37 2.62 4.82 4.91 5.92a.38.38 0 01.21.32.4.4 0 01-.18.34l-.12.06L88.68 467l9.32-3.46 21.51-12.82a.33.33 0 01.14 0c3.12-.45 6.69-2.56 7.18-5.59a.38.38 0 01.21-.28.37.37 0 01.34 0l1.89 1.07a.39.39 0 01.19.33v6.95a1.13 1.13 0 010 .26v.14a.73.73 0 010 .21 4.9 4.9 0 01-2.79 3.94l-29.73 17.49a13.11 13.11 0 01-6.08 1.5zm-.27-.75a12.51 12.51 0 006-1.4l29.67-17.51a4.18 4.18 0 002.41-3.34.76.76 0 000-.14v-.2a.92.92 0 000-.15v-6.81l-1.25-.72c-.82 3.11-4.36 5.19-7.63 5.68l-21.52 12.81-9.49 3.51a.44.44 0 01-.3 0l-30.07-15.83a.36.36 0 01-.2-.32.39.39 0 01.18-.33l.13-.07c-2.14-1.3-3.41-3.65-4.64-5.92l-.09-.15-1.69 1h-.09l-.93.26v6.85c0 1.29.87 2.51 2.46 3.44l30.12 17.77a13.54 13.54 0 006.77 1.58.45.45 0 01.16 0z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-33",
    "data-name": "Path",
    className: "header-section-image_svg__cls-4",
    d: "M83.48 468l-30.12-17.43c-3.53-2.05-3.53-5.38 0-7.42l30.12-17.47a14.15 14.15 0 0112.8 0l30.12 17.47c3.52 2 3.52 5.37 0 7.42L96.28 468a14.09 14.09 0 01-12.8 0z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M89.87 469.92a14.55 14.55 0 01-6.56-1.56l-30.14-17.47c-1.83-1.06-2.83-2.49-2.83-4s1-3 2.83-4l30.12-17.46a14.56 14.56 0 0113.16 0l30.14 17.47c1.82 1.06 2.82 2.5 2.82 4s-1 3-2.82 4l-30.13 17.45a14.53 14.53 0 01-6.59 1.57zm-6.21-2.23a13.79 13.79 0 0012.45 0l30.11-17.45c1.58-.92 2.45-2.12 2.45-3.38s-.87-2.47-2.46-3.39L96.09 426a13.77 13.77 0 00-12.44 0l-30.11 17.47c-1.58.92-2.46 2.12-2.46 3.39s.88 2.46 2.46 3.38z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-34",
    "data-name": "Path",
    className: "header-section-image_svg__cls-5",
    d: "M68.87 392.36v36.36a2.52 2.52 0 001.45 2.11l30.06 17.44c2.16 1.26 5.93 1.1 8.43-.34 1.4-.82 2.11-1.86 2.07-2.85v-36.32z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M104.05 449.49a7.81 7.81 0 01-3.86-.9l-30-17.43a2.89 2.89 0 01-1.64-2.41v-36.94l42.75 16.69v36.58c0 1.15-.78 2.31-2.25 3.17a10.16 10.16 0 01-5 1.24zm-34.8-56.58v35.81a2.1 2.1 0 001.23 1.77L100.56 448c2.06 1.19 5.67 1 8.06-.35 1.23-.71 1.92-1.63 1.88-2.5V409z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-35",
    "data-name": "Path",
    className: "header-section-image_svg__cls-5",
    d: "M102.47 449a11.93 11.93 0 006.8-1.06c1.55-.81 2.32-1.85 2.28-2.83l-.7-37.62-8.22-1.49h-.16z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M104.09 449.49a11.62 11.62 0 01-1.67-.11h-.33v-43.77h.54l8.59 1.57.7 37.94c0 1.15-.85 2.3-2.47 3.16a12.36 12.36 0 01-5.36 1.21zm-1.25-.81a11.61 11.61 0 006.27-1.07c1.35-.71 2.1-1.61 2.07-2.47l-.7-37.33-7.64-1.41z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-36-2",
    "data-name": "Path",
    className: "header-section-image_svg__cls-5",
    d: "M100.38 410.83l-30-17c-2.15-1.23-1.89-3.37.61-4.81 2.49-1.42 6.27-1.57 8.44-.34l30 17c2.16 1.23 1.89 3.38-.61 4.81-2.51 1.41-6.28 1.57-8.44.34z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M104.05 412a7.85 7.85 0 01-3.85-.87l-30-17a2.84 2.84 0 01-1.65-2.4 3.85 3.85 0 012.25-3.06c2.6-1.47 6.55-1.62 8.81-.33l30 17a2.84 2.84 0 011.65 2.4 3.81 3.81 0 01-2.25 3.05 10.25 10.25 0 01-4.96 1.21zM75.7 388.19a9.58 9.58 0 00-4.58 1.12c-1.19.69-1.88 1.57-1.87 2.41a2.11 2.11 0 001.26 1.75l30.05 17c2.06 1.17 5.67 1 8.07-.33 1.19-.69 1.88-1.57 1.87-2.41a2.12 2.12 0 00-1.27-1.75l-30-17a7.2 7.2 0 00-3.53-.79z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-37",
    "data-name": "Path",
    className: "header-section-image_svg__cls-5",
    d: "M104.81 409.39a2.63 2.63 0 01-2.65-2.61v-16.16c0-5.51-4.1-12.49-9-15.24l-7-4c-1.86-1.05-3.55-1.32-4.62-.7s-1.69 2.16-1.69 4.28v16.16a2.66 2.66 0 01-5.31 0V375c0-4.09 1.53-7.22 4.34-8.8s6.33-1.34 9.94.7l7 4c6.52 3.7 11.62 12.38 11.62 19.77v16.16a2.64 2.64 0 01-2.66 2.61z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-2",
    d: "M104.81 409.76a3 3 0 01-3-3v-16.14c0-5.4-4-12.23-8.77-14.91l-7-4c-1.76-1-3.31-1.25-4.26-.71s-1.49 2-1.49 4v16.16a3 3 0 01-6.06 0V375c0-4.24 1.61-7.48 4.53-9.13s6.58-1.4 10.3.71l7 4c6.63 3.76 11.81 12.59 11.81 20.09v16.16a3 3 0 01-3.06 2.93zM82.9 370a7.38 7.38 0 013.46 1.08l7 4c5 2.8 9.15 9.93 9.15 15.56v16.16a2.29 2.29 0 004.57 0v-16.18c0-7.26-5-15.8-11.44-19.44l-7-4c-3.48-2-6.88-2.23-9.56-.71S74.92 371 74.92 375v16.16a2.29 2.29 0 004.57 0V375c0-2.25.68-3.93 1.87-4.61a3.08 3.08 0 011.54-.39z"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "header-section-image_svg__cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#header-section-image_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-11",
    d: "M78.24 355.18a12.5 12.5 0 00-11.3 0c-3.12 1.81-3.1 4.75 0 6.55a12.46 12.46 0 0011.31 0c3.11-1.8 3.09-4.74 0-6.55"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#header-section-image_svg__clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-11",
    d: "M75.85 356.57a7.18 7.18 0 00-6.51 0c-1.8 1-1.79 2.74 0 3.78a7.22 7.22 0 006.53 0c1.79-1 1.78-2.74 0-3.78"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "header-section-image_svg__Path-40-2",
    "data-name": "Path-40",
    className: "header-section-image_svg__cls-11",
    d: "M444.75 306.86l-6.75-4.09 6.75-4.08 6.74 4.06-6.74 4.11z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "header-section-image_svg__cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#header-section-image_svg__clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-11",
    d: "M300.33 285a12.5 12.5 0 00-11.3 0c-3.12 1.81-3.1 4.75 0 6.56a12.46 12.46 0 0011.31 0c3.11-1.81 3.1-4.75 0-6.56"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#header-section-image_svg__clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-11",
    d: "M297.94 286.35a7.18 7.18 0 00-6.51 0c-1.8 1-1.79 2.74 0 3.78a7.22 7.22 0 006.53 0c1.78-1 1.78-2.73 0-3.78"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "header-section-image_svg__cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#header-section-image_svg__clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-11",
    d: "M327.9 510.08a12.49 12.49 0 00-11.31 0c-3.11 1.8-3.09 4.74 0 6.54a12.47 12.47 0 0011.3 0c3.12-1.81 3.1-4.75 0-6.56"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#header-section-image_svg__clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-11",
    d: "M325.51 511.48a7.14 7.14 0 00-6.52 0c-1.79 1-1.78 2.73 0 3.77a7.2 7.2 0 006.52 0c1.79-1 1.78-2.73 0-3.77"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "header-section-image_svg__cls-1",
    d: "M0 0h540v540H0z"
  })));
}

export default __webpack_public_path__ + "static/header-section-image.9c93aabd.svg";
export { SvgHeaderSectionImage as ReactComponent };